import React, { useEffect, useState, useRef } from "react";
import api from "../../api/api";

//~----------------Toast component and Sweet Alert-----------------------------
import { ToastContainer, toast } from "react-toastify";
import Swal from "sweetalert2";

//~--------------------Header component---------------------------------------------
import MuiHeader from "../../components/MuiHeader";

//~------------------------------MUI components---------------------------------------
import {
  Button,
  Box,
  TextField,
  Select,
  InputLabel,
  MenuItem,
  FormControl,
  OutlinedInput,
  Chip,
  Checkbox,
  Radio,
  ListItemText,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  useStepContext,
  CircularProgress,
  Typography,
} from "@mui/material";
import Modal from "@mui/material/Modal";
import DeleteIcon from "@mui/icons-material/Delete";
import ModeEditOutlineIcon from "@mui/icons-material/ModeEditOutline";

//~-------------------------------Azure Components to upload and delete media------------------
import { deleteFileFromDB, UploadFileToAzureDB } from "../../components/Azure";
import {
  getAllModules,
  getAllProgramTypes,
  getAllTopics,
  getAllsubModules,
} from "../PedagogySection/Pedagogy.Thunk";

import {
  saveGamifiedQuiz,
  getAllGamifiedQuizzes,
  updateGamifiedQuiz,
  deleteGamifiedQuiz,
} from "./GamifiedModule.thunk";

const GamifiedModule = () => {
  //&-----------------Dropdown elements--------------------
  const language_select_option_list = [
    { value: "od", text: "ଓଡିଆ" },
    { value: "en", text: "English" },
  ];

  const usertype_select_option_list = [
    { value: "fellow", text: "Educator" },
    { value: "Anganwadi", text: "Anganwadi" },
    { value: "school", text: "School" },
    { value: "cci", text: "CCI" },
  ];
  const type_select_option_list = [
    { value: "training", text: "Teacher Training" },
    { value: "activity", text: "Student Activity" },
  ];

  const getColorByIndex = (index) => {
    const colors = [
      "#ff9999", // Brighter red
      "#ffb380", // Brighter orange
      "#ffff99", // Brighter yellow
      "#90ee90", // Brighter green
      "#87cefa", // Brighter blue
      "#d8bfd8", // Brighter purple
      "#c6c6f9", // Brighter violet
    ];
    return colors[index % colors.length];
  };

  //?----------------States for training type---------
  const [type, setType] = useState("");
  const [preferedlanguage, setPreferedlanguage] = useState("od");
  const [usertype, setUsertype] = useState("");
  const [programtype, setProgramtype] = useState("");
  const [programData, setProgramData] = useState([]);
  const trainingTypeArray =
    usertype === "cci"
      ? [
          {
            trainingType: "training1",
            trainingName: "21st Century Skills",
          },

          {
            trainingType: "training3",
            trainingName: "Pedagogy",
          },
        ]
      : [
          {
            trainingType: "training1",
            trainingName: "21st Century Skills",
          },
          {
            trainingType: "training2",
            trainingName: "Technology",
          },
          {
            trainingType: "training3",
            trainingName: "Pedagogy",
          },
        ];
  const [modules, setModules] = useState([]);
  const [selModuleDetails, setSelModuleDetails] = useState("");
  const [subModules, setSubModules] = useState([]);
  const [selSubModuleDetails, setSelSubModuleDetails] = useState("");
  const [topics, setTopics] = useState([]);
  const [selTopicDetails, setSelTopicDetails] = useState("");
  const [quizzType, setQuizzType] = useState("");
  const [assignmentData, setAssignmentData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingSave, setLoadingSave] = useState(false);
  const [loadingUpdate, setLoadingUpdate] = useState(false);

  //?-------------States for the gamified quizes--------
  const quizMediaFileRef = useRef();
  const [show, setShow] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [fileExtensionType, setFileExtensionType] = useState("");
  const [myFile, setMyFile] = useState("");
  const [accept, setAccept] = useState("");
  const [questionMediaType, setQuestionMediaType] = useState("");
  const [showUploadPanel, setShowUploadPanel] = useState(false);
  //^-------------------- All answer types------------------------------------------------
  const [showOptions2, setShowOptions2] = useState(false);
  const [showOptions3, setShowOptions3] = useState(false);
  const [showOptions4, setShowOptions4] = useState(false);
  const [showOptionsYN, setShowOptionsYN] = useState(false);
  const [answerType, setAnswerType] = useState("");

  //^---------------------- optionMediaType (whether text or image)-------------------------
  const [optionMediaType, setOptionMediaType] = useState("");

  //^---------------------- Question set and Question media selection -------------------------
  const [questionOrder, setQuestionOrder] = useState(0);
  const [questionId, setQuestionId] = useState("");
  const [question, setQuestion] = useState("");
  const [questionMedia, setQuestionMedia] = useState("");

  //^--------------------- Instruction -------------------------
  const [instructions, setInstructions] = useState("");

  //^--------------------- Hints -------------------------
  const [hints, setHints] = useState("");

  const [filePreview, setFilePreview] = useState(null);

  //^--------------QuizData--------------------------------
  const [quizes, setQuizes] = useState([]);
  const [selectedExercise, setSelectedExercise] = useState("");
  const [rearrangeSentence, setRearrangeSentence] = useState("");
  const [rearrangeSentenceArray, setRearrangeSentenceArray] = useState([]);
  const [puzzleQuestions, setPuzzleQuestions] = useState([{ wordValue: "" }]);
  const [sentenceRearrangements, setSentenceRearrangements] = useState([
    { wordValue: "" },
  ]);
  const [paragraphText, setParagraphText] = useState("");
  const [paragraphOptions, setParagraphOptions] = useState([""]);
  const [answers, setAnswers] = useState([]);
  const [fillInBlanksArr, setFillInBlanksArr] = useState([
    {
      text: "",
      correctInput: [],
      options: [],
    },
  ]);

  const handleChange = (event) => {
    setSelectedExercise(event.target.value);
    console.log("selectedExercise", event.target.value);
    setRearrangeSentence("");
    setCorrectOption("");
    setOptionMediaType("");
    setAnswerType("");
    setQuestionMedia("");
  };

  useEffect(() => {
    const data = {
      language: preferedlanguage,
      usertype: "fellow",
    };
    // getAllProgramTypes(data).then((modules) => {
    //   setProgramData(modules.data);
    // });
  }, []);

  //*---------Language change function--------
  const preflanguage_select_onchange = (e) => {
    if (!e.target.value) {
      setPreferedlanguage("");
      setUsertype("");
      setProgramtype("");
      setModules([]);
      setSelModuleDetails("");
      setSubModules([]);
      setSelSubModuleDetails("");
      setTopics([]);
      setSelTopicDetails("");
    } else {
      setUsertype("");
      setProgramtype("");
      setSelModuleDetails("");
      setSelSubModuleDetails("");
      setSelTopicDetails("");
      setPreferedlanguage(e.target.value);
      setQuizes([]);
    }
  };

  //*----------Usertype change function--------
  const usertype_select_onchange = (e) => {
    if (!e.target.value) {
      setUsertype("");
      setProgramtype("");
      setProgramData([]);
      setModules([]);
      setSelModuleDetails("");
      setSubModules([]);
      setSelSubModuleDetails("");
      setTopics([]);
      setSelTopicDetails("");
      setQuizes([]);
    } else {
      setUsertype(e.target.value);
      setProgramtype("");
      setSelModuleDetails("");
      setSelSubModuleDetails("");
      setSelTopicDetails("");
      setQuizes([]);
      setLoading(true);
      const data = {
        language: preferedlanguage,
        usertype: e.target.value,
      };
      // getAllProgramTypes(data).then((modules) => {
      //   setProgramData(modules.data);
      //   setLoading(false);
      // });
    }
  };

  //*---------Programtype change function---------
  const program_select_onchange = (event) => {
    if (!event.target.value) {
      setProgramtype("");
      setQuizes([]);
      setModules([]);
      setSelModuleDetails("");
      setSubModules([]);
      setSelSubModuleDetails("");
      setTopics([]);
      setSelTopicDetails("");
    } else {
      setLoading(true);
      setProgramtype(event.target.value);
      setSelModuleDetails("");
      setSelSubModuleDetails("");
      setSelTopicDetails("");
      setQuizes([]);
      const data = {
        trainingType: event.target.value,
        usertype: usertype,
        language: preferedlanguage,
      };

      getAllModules(data).then((modules) => {
        setModules(modules.data);
        setLoading(false);
      });
    }
  };

  //*------------Module change function------------
  const module_select_onchange = (e) => {
    if (!e.target.value) {
      setSelModuleDetails("");
      setQuizes([]);
      setSubModules([]);
      setSelSubModuleDetails("");
      setTopics([]);
      setSelTopicDetails("");
    } else {
      setLoading(true);
      setQuizes([]);
      setSelModuleDetails(e.target.value);
      setSelSubModuleDetails("");
      setSelTopicDetails("");
      const data = {
        usertype: usertype,
        language: preferedlanguage,
        trainingType: programtype,
        moduleid: e.target.value,
      };
      getAllsubModules(data).then((submodules) => {
        setSubModules(submodules.data);
        setLoading(false);
      });
    }
  };

  //*-------------Submodule change function---------
  const submodule_select_onchange = (e) => {
    if (!e.target.value) {
      setSelSubModuleDetails("");
      setSelTopicDetails("");
      setTopics([]);
      setQuizes([]);
    } else {
      setLoading(true);
      setQuizes([]);
      setSelSubModuleDetails(e.target.value);
      setSelTopicDetails("");
      setTopics([]);

      const data = {
        trainingType: programtype,
        usertype: usertype,
        language: preferedlanguage,
        moduleid: selModuleDetails,
        submoduleid: e.target.value,
      };

      getAllTopics(data).then((topic) => {
        setTopics(topic.data);
        setLoading(false);
      });
    }
  };

  //*----------------topic change function------------
  const topic_select_onchange = (e) => {
    if (!e.target.value) {
      setSelTopicDetails("");
      setAssignmentData([]);
      setSelTopicDetails("");
      setQuizes([]);
    } else {
      setSelTopicDetails(e.target.value);
      setLoading(true);
      console.log(
        "selTopicDetails.topicId------------------>",
        e.target.value.topicId
      );
      getAllGamifiedQuizzes(e.target.value.topicId)
        .then((res) => {
          if (res.status === 200) {
            setQuizes(res.data);
            setLoading(false);
          } else if (res.status === 204) {
            toast.info("No quiz is there to display !");
            setLoading(false);
          } else {
            toast.error("Please try again later");
            setLoading(false);
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status === 500) {
              toast.error("Internal server error. Please try again later.");
              console.error(
                "The error while fetching gamified Quiz------------------------->",
                error
              );
              setLoading(false);
            } else if (error.response.status === 504) {
              toast.error("Server timeout error. Please try again later.");
              console.error(
                "The error while fetching gamified Quiz------------------------->",
                error
              );
              setLoading(false);
            } else {
              toast.error(
                "An unexpected error occurred. Please try again later."
              );
              console.error(
                "The error while fetching gamified Quiz------------------------->",
                error
              );
              setLoading(false);
            }
          } else {
            toast.error("Some internal error occured. Please try again later.");
            console.error(
              "The error while saving gamified Quiz------------------------->",
              error
            );
          }
        });
    }
  };

  // ---------------------- Quiz Type ------------------------
  const quiz_type_select_on_change = (e) => {
    setCorrectOption("");
    // reset();
    if (!e.target.value) {
      setShowOptions2(false);
      setShowOptions3(false);
      setShowOptions4(false);
      setShowOptionsYN(false);
    } else {
      setAnswerType(e.target.value);
      if (e.target.value === "2options") {
        setShowOptions2(true);
        setShowOptions3(false);
        setShowOptions4(false);
        setShowOptionsYN(false);
        setOptionA("");
        setOptionB("");
        setOptionC("");
        setOptionD("");
      } else if (e.target.value === "3options") {
        setShowOptions2(false);
        setShowOptions3(true);
        setShowOptions4(false);
        setShowOptionsYN(false);
        setOptionA("");
        setOptionB("");
        setOptionC("");
        setOptionD("");
      } else if (e.target.value === "4options") {
        setShowOptions2(false);
        setShowOptions3(false);
        setShowOptions4(true);
        setShowOptionsYN(false);
        setOptionA("");
        setOptionB("");
        setOptionC("");
        setOptionD("");
      } else {
        setShowOptions2(false);
        setShowOptions3(false);
        setShowOptions4(false);
        setShowOptionsYN(true);
        setOptionA("");
        setOptionB("");
        setOptionC("");
        setOptionD("");
      }
    }
  };
  // ---------------------------------------------------------

  // ---------------------- Correct Answer -------------------
  const [correctOption, setCorrectOption] = useState([]);
  const correct_answer_select_on_change = (e) => {
    const {
      target: { value },
    } = e;

    const myValue = typeof value === "string" ? value.split(",") : value;
    console.log("myValue---------->", myValue);

    // setCorrectOption(
    //   myValue[0] === "a"
    //     ? "optionA"
    //     : myValue[0] === "b"
    //     ? "optionB"
    //     : myValue[0] === "c"
    //     ? "optionC"
    //     : myValue[0] === "d"
    //     ? "optionD"
    //     : myValue
    // );
    setCorrectOption(myValue);
  };
  // ---------------------------------------------------------

  console.log("correct option selected------->", correctOption);

  //On Modal close and open
  const handleShow = () => setShow(true);
  const handleClose = () => {
    setShow(false);
    setOptionMediaType("");
    setSelectedExercise("");
    setAnswerType("");
    setInstructions("");
    setQuestion("");
    setOptionA("");
    setOptionB("");
    setOptionC("");
    setOptionD("");
    setCorrectOption("");
    setHints("");
    setRearrangeSentenceArray([]);
    setRearrangeSentence("");
    setSelectedExercise("");
    setPuzzleQuestions([{ wordValue: "" }]);
    setSentenceRearrangements([{ wordValue: "" }]);
    setParagraphText("");
    setParagraphOptions([""]);
    setAnswers([]);

    setMatchingQuestions([{ ltype: "", left: "", rtype: "", right: "" }]);
  };

  //^------------------onChange function to select files for the questionMedia----------
  const quiz_media_file_on_change = async (e) => {
    const file = e.target.files[0];
    const maxHeight = 612;
    const maxWidth = 612;

    if (file) {
      const fileExtension = file.name.split(".").pop().toLowerCase();
      const fileType = file.type;

      if (accept === "image/*" && file.size > 2097152) {
        toast.error("File size exceeds the maximum allowed (2 MB)");
        return;
      } else if (accept === "audio/*" && file.size > 5948300) {
        toast.error("File size exceeds the maximum allowed (4 MB)");
        return;
      } else if (accept === "video/*" && file.size > 20971520) {
        toast.error("File size exceeds the maximum allowed (20 MB)");
        return;
      }

      if (fileType.startsWith("video/")) {
        setFileExtensionType("mp4");
        const generatedFileName = `quiz_${new Date().getTime()}.mp4`;
        setFileName(generatedFileName);
        setSelectedFile(file);

        const videoUrl = URL.createObjectURL(file); // Create a URL for the video file
        setMyFile(videoUrl); // Set the file URL

        await uploadIfReady(file, generatedFileName);
      } else if (fileType.startsWith("audio/")) {
        setFileExtensionType("mp3");
        const generatedFileName = `quiz_${new Date().getTime()}.mp3`;
        setFileName(generatedFileName);
        setSelectedFile(file);

        setMyFile(URL.createObjectURL(file)); // Set the audio file URL

        await uploadIfReady(file, generatedFileName);
      } else if (fileType.startsWith("image/")) {
        const reader = new FileReader();

        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;

          img.onload = async () => {
            const { width, height } = img;

            if (width > maxWidth || height > maxHeight) {
              toast.error("Maximum height and width exceeded");
              return;
            }

            let generatedFileName;
            if (fileExtension === "png" || fileType === "image/png") {
              setFileExtensionType("png");
              generatedFileName = `quiz_${new Date().getTime()}.png`;
            } else if (
              fileExtension === "jpg" ||
              fileExtension === "jpeg" ||
              fileType === "image/jpeg"
            ) {
              setFileExtensionType("jpg");
              generatedFileName = `quiz_${new Date().getTime()}.jpg`;
            } else {
              console.error("It is neither a PNG nor a JPG file.");
              return;
            }

            setFileName(generatedFileName);
            setSelectedFile(file);

            setMyFile(e.target.result);

            await uploadIfReady(file, generatedFileName);
          };
        };

        reader.readAsDataURL(file);
      } else {
        console.error("Unsupported file type");
        return;
      }
    }
  };
  //^---------------function to send file to Azure DB and fetch the URL------------------
  const uploadIfReady = async (file, fileName) => {
    if (file && fileName) {
      try {
        const uploadFile = await UploadFileToAzureDB(file, fileName);
        setQuestionMedia(uploadFile);
        setUpdateData({ ...updateData, gameQuestionMedia: uploadFile.url });
        console.log("uploadFile response question:---------- ", uploadFile);
      } catch (error) {
        console.error("Error uploading file: ", error);
        setQuestionMedia("");
      }
    }
  };
  //^---------------deleting the url  from the Azure DB-------------------------------------
  const quiz_media_file_on_delete = async (item) => {
    console.log("item---------------->", item);
    try {
      deleteFileFromDB(item);
      setQuestionMedia("");
      setUpdateData({ ...updateData, gameQuestionMedia: "" });
    } catch (error) {
      console.error("The error in deleting from Azure------------>", error);
    }
  };

  //?!----------------This contains all the functionalities and the required states to hold the url for all the options--------------
  // ---------------------- Options --------------------------
  const [optionA, setOptionA] = useState("");
  const [optionB, setOptionB] = useState("");
  const [optionC, setOptionC] = useState("");
  const [optionD, setOptionD] = useState("");
  // ---------------------------------------------------------

  //--------------------------handle option A-------------------------
  const handleOptionAchange = async (e) => {
    if (optionMediaType === "text") {
      setOptionA(e.target.value);
    } else if (optionMediaType === "audio") {
      const file = e.target.files[0];
      if (file) {
        const fileExtension = file.name.split(".").pop().toLowerCase();
        const fileType = file.type;

        // Check for audio file size (2 MB in this case)
        if (accept === "audio/*" && file.size > 2097152) {
          toast.error("File size exceeds the maximum allowed (2 MB)");
          return;
        }

        if (fileType.startsWith("audio/")) {
          let generatedFileName;

          // Handle supported audio types (e.g., mp3, wav)
          if (fileExtension === "mp3" || fileType === "audio/mpeg") {
            generatedFileName = `optionA_${new Date().getTime()}.mp3`;
          } else if (fileExtension === "wav" || fileType === "audio/wav") {
            generatedFileName = `optionA_${new Date().getTime()}.wav`;
          } else {
            toast.error("Unsupported audio file type");
            return;
          }

          setFileName(generatedFileName);
          setSelectedFile(file);

          await uploadIfReadyOptionA(file, generatedFileName);
        } else {
          toast.error("Unsupported file type");
          return;
        }
      }
    } else {
      const file = e.target.files[0];
      const maxHeight = 612;
      const maxWidth = 612;
      if (file) {
        const fileExtension = file.name.split(".").pop().toLowerCase();
        const fileType = file.type;
        if (accept === "image/*" && file.size > 2097152) {
          toast.error("File size exceeds the maximum allowed (2 MB)");
          return;
        }
        if (fileType.startsWith("image/")) {
          const reader = new FileReader();

          reader.onload = (e) => {
            const img = new Image();
            img.src = e.target.result;

            img.onload = async () => {
              const { width, height } = img;

              if (width > maxWidth || height > maxHeight) {
                toast.error("Maximum height and width exceeded");
                return;
              }

              let generatedFileName;
              if (fileExtension === "png" || fileType === "image/png") {
                setFileExtensionType("png");
                generatedFileName = `optionA_${new Date().getTime()}.png`;
              } else if (
                fileExtension === "jpg" ||
                fileExtension === "jpeg" ||
                fileType === "image/jpeg"
              ) {
                setFileExtensionType("jpg");
                generatedFileName = `optionA_${new Date().getTime()}.jpg`;
              } else {
                console.error("It is neither a PNG nor a JPG file.");
                return;
              }

              setFileName(generatedFileName);
              setSelectedFile(file);

              setMyFile(e.target.result);

              await uploadIfReadyOptionA(file, generatedFileName);
            };
          };

          reader.readAsDataURL(file);
        } else {
          console.error("Unsupported file type");
          return;
        }
      }
    }
  };

  const uploadIfReadyOptionA = async (file, fileName) => {
    try {
      const uploadFileA = await UploadFileToAzureDB(file, fileName);
      setOptionA(uploadFileA.url);
      setUpdateData({ ...updateData, optionA: uploadFileA.url });
      console.log("optionA response:---------- ", uploadFileA.url);
    } catch (error) {
      console.error("Error uploading file: ", error);
      setOptionA("");
    }
  };

  const optionADelete = async (item) => {
    console.log("data received to delete in option A---------------->", item);
    try {
      // Remove the file from the database
      await deleteFileFromDB(item);

      // Clear optionA
      setOptionA("");

      // Update updateData by setting optionA in correctAnswer[0] to an empty string
      setUpdateData((prevData) => {
        const updatedCorrectAnswer = [...prevData.correctAnswer]; // Copy the existing correctAnswer array
        updatedCorrectAnswer[0].optionA = ""; // Clear the optionA at index 0

        return {
          ...prevData,
          correctAnswer: updatedCorrectAnswer, // Update correctAnswer with the modified array
        };
      });
    } catch (error) {
      console.error(
        "The error in deleting optionA from Azure------------>",
        error
      );
    }
  };

  //----------------------------------------------------------------------

  //--------------------------------handle option B---------------------------
  const handleOptionBchange = async (e) => {
    if (optionMediaType === "text") {
      setOptionB(e.target.value);
    } else if (optionMediaType === "audio") {
      const file = e.target.files[0];
      if (file) {
        const fileExtension = file.name.split(".").pop().toLowerCase();
        const fileType = file.type;

        // Check for audio file size (2 MB limit)
        if (accept === "audio/*" && file.size > 2097152) {
          toast.error("File size exceeds the maximum allowed (2 MB)");
          return;
        }

        if (fileType.startsWith("audio/")) {
          let generatedFileName;

          // Handle supported audio types (e.g., mp3, wav)
          if (fileExtension === "mp3" || fileType === "audio/mpeg") {
            generatedFileName = `optionB_${new Date().getTime()}.mp3`;
          } else if (fileExtension === "wav" || fileType === "audio/wav") {
            generatedFileName = `optionB_${new Date().getTime()}.wav`;
          } else {
            toast.error("Unsupported audio file type");
            return;
          }

          setFileName(generatedFileName);
          setSelectedFile(file);

          await uploadIfReadyOptionB(file, generatedFileName);
        } else {
          toast.error("Unsupported file type");
          return;
        }
      }
    } else {
      const file = e.target.files[0];
      const maxHeight = 612;
      const maxWidth = 612;
      if (file) {
        const fileExtension = file.name.split(".").pop().toLowerCase();
        const fileType = file.type;
        if (accept === "image/*" && file.size > 2097152) {
          toast.error("File size exceeds the maximum allowed (2 MB)");
          return;
        }
        if (fileType.startsWith("image/")) {
          const reader = new FileReader();

          reader.onload = (e) => {
            const img = new Image();
            img.src = e.target.result;

            img.onload = async () => {
              const { width, height } = img;

              if (width > maxWidth || height > maxHeight) {
                toast.error("Maximum height and width exceeded");
                return;
              }

              let generatedFileName;
              if (fileExtension === "png" || fileType === "image/png") {
                setFileExtensionType("png");
                generatedFileName = `optionB_${new Date().getTime()}.png`;
              } else if (
                fileExtension === "jpg" ||
                fileExtension === "jpeg" ||
                fileType === "image/jpeg"
              ) {
                setFileExtensionType("jpg");
                generatedFileName = `optionB_${new Date().getTime()}.jpg`;
              } else {
                console.error("It is neither a PNG nor a JPG file.");
                return;
              }

              setFileName(generatedFileName);
              setSelectedFile(file);

              setMyFile(e.target.result);

              await uploadIfReadyOptionB(file, generatedFileName);
            };
          };

          reader.readAsDataURL(file);
        } else {
          console.error("Unsupported file type");
          return;
        }
      }
    }
  };

  const uploadIfReadyOptionB = async (file, fileName) => {
    try {
      const uploadFileB = await UploadFileToAzureDB(file, fileName);
      setOptionB(uploadFileB.url);
      setUpdateData({ ...updateData, optionB: uploadFileB.url });
      console.log("optionB response:---------- ", uploadFileB.url);
    } catch (error) {
      console.error("Error uploading file: ", error);
      setOptionB("");
    }
  };
  const optionBDelete = async (item) => {
    console.log("data received to delete in option B---------------->", item);
    try {
      await deleteFileFromDB(item);
      setOptionB("");
      setUpdateData((prevData) => {
        const updatedCorrectAnswer = [...prevData.correctAnswer];
        updatedCorrectAnswer[0].optionB = "";

        return {
          ...prevData,
          correctAnswer: updatedCorrectAnswer,
        };
      });
    } catch (error) {
      console.error(
        "The error in deleting optionA from Azure------------>",
        error
      );
    }
  };

  //------------------------------------------------------------------------------

  //---------------------------------Handle option C--------------------------
  const handleOptionCchange = async (e) => {
    if (optionMediaType === "text") {
      setOptionC(e.target.value);
    } else if (optionMediaType === "audio") {
      const file = e.target.files[0];
      if (file) {
        const fileExtension = file.name.split(".").pop().toLowerCase();
        const fileType = file.type;

        // Check for audio file size (2 MB limit)
        if (accept === "audio/*" && file.size > 2097152) {
          toast.error("File size exceeds the maximum allowed (2 MB)");
          return;
        }

        if (fileType.startsWith("audio/")) {
          let generatedFileName;

          // Handle supported audio types (e.g., mp3, wav)
          if (fileExtension === "mp3" || fileType === "audio/mpeg") {
            generatedFileName = `optionC_${new Date().getTime()}.mp3`;
          } else if (fileExtension === "wav" || fileType === "audio/wav") {
            generatedFileName = `optionC_${new Date().getTime()}.wav`;
          } else {
            toast.error("Unsupported audio file type");
            return;
          }

          setFileName(generatedFileName);
          setSelectedFile(file);

          await uploadIfReadyOptionC(file, generatedFileName);
        } else {
          toast.error("Unsupported file type");
          return;
        }
      }
    } else {
      const file = e.target.files[0];
      const maxHeight = 612;
      const maxWidth = 612;
      if (file) {
        const fileExtension = file.name.split(".").pop().toLowerCase();
        const fileType = file.type;
        if (accept === "image/*" && file.size > 2097152) {
          toast.error("File size exceeds the maximum allowed (2 MB)");
          return;
        }
        if (fileType.startsWith("image/")) {
          const reader = new FileReader();

          reader.onload = (e) => {
            const img = new Image();
            img.src = e.target.result;

            img.onload = async () => {
              const { width, height } = img;

              if (width > maxWidth || height > maxHeight) {
                toast.error("Maximum height and width exceeded");
                return;
              }

              let generatedFileName;
              if (fileExtension === "png" || fileType === "image/png") {
                setFileExtensionType("png");
                generatedFileName = `optionC_${new Date().getTime()}.png`;
              } else if (
                fileExtension === "jpg" ||
                fileExtension === "jpeg" ||
                fileType === "image/jpeg"
              ) {
                setFileExtensionType("jpg");
                generatedFileName = `optionC_${new Date().getTime()}.jpg`;
              } else {
                console.error("It is neither a PNG nor a JPG file.");
                return;
              }

              setFileName(generatedFileName);
              setSelectedFile(file);

              setMyFile(e.target.result);

              await uploadIfReadyOptionC(file, generatedFileName);
            };
          };

          reader.readAsDataURL(file);
        } else {
          console.error("Unsupported file type");
          return;
        }
      }
    }
  };

  const uploadIfReadyOptionC = async (file, fileName) => {
    try {
      const uploadFileC = await UploadFileToAzureDB(file, fileName);
      setOptionC(uploadFileC.url);
      setUpdateData({ ...updateData, optionC: uploadFileC.url });
      console.log("optionC response:---------- ", uploadFileC.url);
    } catch (error) {
      console.error("Error uploading file: ", error);
      setOptionC("");
    }
  };
  const optionCDelete = async (item) => {
    console.log("data received to delete in option C---------------->", item);
    try {
      await deleteFileFromDB(item);
      setOptionC("");
      setUpdateData((prevData) => {
        const updatedCorrectAnswer = [...prevData.correctAnswer];
        updatedCorrectAnswer[0].optionC = "";

        return {
          ...prevData,
          correctAnswer: updatedCorrectAnswer,
        };
      });
    } catch (error) {
      console.error(
        "The error in deleting optionA from Azure------------>",
        error
      );
    }
  };
  //-----------------------------------------------------------------------------

  //---------------------------------Handle option C--------------------------
  const handleOptionDchange = async (e) => {
    if (optionMediaType === "text") {
      setOptionD(e.target.value);
    } else if (optionMediaType === "audio") {
      const file = e.target.files[0];
      if (file) {
        const fileExtension = file.name.split(".").pop().toLowerCase();
        const fileType = file.type;

        // Check for audio file size (2 MB limit)
        if (accept === "audio/*" && file.size > 2097152) {
          toast.error("File size exceeds the maximum allowed (2 MB)");
          return;
        }

        if (fileType.startsWith("audio/")) {
          let generatedFileName;

          // Handle supported audio types (e.g., mp3, wav)
          if (fileExtension === "mp3" || fileType === "audio/mpeg") {
            generatedFileName = `optionD_${new Date().getTime()}.mp3`;
          } else if (fileExtension === "wav" || fileType === "audio/wav") {
            generatedFileName = `optionD_${new Date().getTime()}.wav`;
          } else {
            toast.error("Unsupported audio file type");
            return;
          }

          setFileName(generatedFileName);
          setSelectedFile(file);

          await uploadIfReadyOptionD(file, generatedFileName);
        } else {
          toast.error("Unsupported file type");
          return;
        }
      }
    } else {
      const file = e.target.files[0];
      const maxHeight = 612;
      const maxWidth = 612;
      if (file) {
        const fileExtension = file.name.split(".").pop().toLowerCase();
        const fileType = file.type;
        if (accept === "image/*" && file.size > 2097152) {
          toast.error("File size exceeds the maximum allowed (2 MB)");
          return;
        }
        if (fileType.startsWith("image/")) {
          const reader = new FileReader();

          reader.onload = (e) => {
            const img = new Image();
            img.src = e.target.result;

            img.onload = async () => {
              const { width, height } = img;

              if (width > maxWidth || height > maxHeight) {
                toast.error("Maximum height and width exceeded");
                return;
              }

              let generatedFileName;
              if (fileExtension === "png" || fileType === "image/png") {
                setFileExtensionType("png");
                generatedFileName = `optionD_${new Date().getTime()}.png`;
              } else if (
                fileExtension === "jpg" ||
                fileExtension === "jpeg" ||
                fileType === "image/jpeg"
              ) {
                setFileExtensionType("jpg");
                generatedFileName = `optionD_${new Date().getTime()}.jpg`;
              } else {
                console.error("It is neither a PNG nor a JPG file.");
                return;
              }

              setFileName(generatedFileName);
              setSelectedFile(file);

              setMyFile(e.target.result);

              await uploadIfReadyOptionD(file, generatedFileName);
            };
          };

          reader.readAsDataURL(file);
        } else {
          console.error("Unsupported file type");
          return;
        }
      }
    }
  };

  const uploadIfReadyOptionD = async (file, fileName) => {
    try {
      const uploadFileD = await UploadFileToAzureDB(file, fileName);
      setOptionD(uploadFileD.url);
      setUpdateData({ ...updateData, optionD: uploadFileD.url });
      console.log("optionD response:---------- ", uploadFileD.url);
    } catch (error) {
      console.error("Error uploading file: ", error);
      setOptionD("");
    }
  };
  const optionDDelete = async (item) => {
    console.log("data received to delete in option D---------------->", item);
    try {
      await deleteFileFromDB(item);
      setOptionD("");
      setUpdateData((prevData) => {
        const updatedCorrectAnswer = [...prevData.correctAnswer];
        updatedCorrectAnswer[0].optionD = "";

        return {
          ...prevData,
          correctAnswer: updatedCorrectAnswer,
        };
      });
    } catch (error) {
      console.error(
        "The error in deleting optionA from Azure------------>",
        error
      );
    }
  };
  //-----------------------------------------------------------------------------
  //?!---------------------------------------------------------------------------------------------------------------------------------------------

  //&--------------------Delete Functionalities for the array of quizes-------------------------------------------------------------
  const deleteQuestionOnClick = (item) => {
    console.log("item received upon deleting --------------------->", item);
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this question?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      //cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        if (item.gameQuestionMedia) {
          //if the question media is there, then we will have to delete that from Azure as well
          quiz_media_file_on_delete(item.gameQuestionMedia);
        }

        if (item.optionMediaType && item.optionMediaType === "image") {
          //If the optionMediaType is image, then also we will be deleting it
          if (answerType === "4options") {
            optionDDelete(item.optionD);
            optionCDelete(item.optionC);
            optionBDelete(item.optionB);
            optionADelete(item.optionA);
          } else if (answerType === "3options") {
            optionCDelete(item.optionC);
            optionBDelete(item.optionB);
            optionADelete(item.optionA);
          } else {
            optionBDelete(item.optionB);
            optionADelete(item.optionA);
          }
        }

        const newQuiz = quizes.filter((x) => x.questionId !== item.questionId); //This new array will be used as updated Quiz Array for the update method
        console.log("NewQuiz------------------->", newQuiz);
        const data = {
          topicId: selTopicDetails.topicId,
          quizType: "gamified",
          gamifiedData: newQuiz,
        };
        console.log("body sent for delete------------------>", data);
        deleteGamifiedQuiz(data)
          .then((res) => {
            if (res.status === 200) {
              toast.success("Successfully deleted the question.");
              getAllGamifiedQuizzes(selTopicDetails.topicId)
                .then((res) => {
                  if (res.status === 200) {
                    setQuizes(res.data);
                    resetAll();
                    handleClose();
                  } else if (res.status === 204) {
                    toast.info("No data is there to display !");
                  } else {
                    toast.info("Please try again later.");
                    console.log(
                      "response status while receiving gamified quizes--------------------->",
                      res.status
                    );
                  }
                })
                .catch((error) => {
                  if (error.response) {
                    if (error.response.status === 500) {
                      console.error(
                        "The error while fetching gamified Quiz------------------------->",
                        error
                      );
                    } else if (error.response.status === 504) {
                      console.error(
                        "The error while fetching gamified Quiz------------------------->",
                        error
                      );
                    } else {
                      console.error(
                        "The error while fetching gamified Quiz------------------------->",
                        error
                      );
                    }
                  } else {
                    toast.error(
                      "Some internal error occured. Please try again later."
                    );
                    console.error(
                      "The error while saving gamified Quiz------------------------->",
                      error
                    );
                  }
                });
            } else {
              toast.error(
                "Sorry, couldn't delete this time. Please try again later !"
              );
              console.log(
                "The status code received-------------------->",
                res.status
              );
            }
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.status === 500) {
                toast.error("Internal server error. Please try again later.");
                console.error(
                  "The error while fetching gamified Quiz------------------------->",
                  error
                );
                setLoading(false);
              } else if (error.response.status === 504) {
                toast.error("Server timeout error. Please try again later.");
                console.error(
                  "The error while fetching gamified Quiz------------------------->",
                  error
                );
                setLoading(false);
              } else {
                toast.error(
                  "An unexpected error occurred. Please try again later."
                );
                console.error(
                  "The error while fetching gamified Quiz------------------------->",
                  error
                );
                setLoading(false);
              }
            } else {
              toast.error(
                "Some internal error occured. Please try again later."
              );
              console.error(
                "The error while saving gamified Quiz------------------------->",
                error
              );
            }
          });
        setQuizes((quizes) =>
          quizes.filter((i) => i.questionId !== item.questionId)
        );
      }
    });
  };
  //&--------------------------------------------------------------------------------------------------------------------------------------

  //^------------------Changing the QuizMedia types---------------------------------------
  const quiz_media_type_select_on_change = (e) => {
    setSelectedFile(null);
    setQuestionMediaType(e.target.value);
    if (e.target.value === "image") {
      setAccept("image/*");
      setShowUploadPanel(true);
    } else if (e.target.value === "audio") {
      setAccept("audio/*");
      setShowUploadPanel(true);
    } else if (e.target.value === "video") {
      setAccept("video/*");
      setShowUploadPanel(true);
    } else {
      setAccept("");
      setShowUploadPanel(false);
    }
  };

  const handleoptionMediaType = (e) => {
    setOptionMediaType(e.target.value);
    setAnswerType("");
    setOptionA("");
    setOptionB("");
    setOptionC("");
    setOptionD("");
    setCorrectOption([]);
  };

  const resetAll = () => {
    setQuestionOrder(0);
    setSelectedFile(null);
    setSelectedExercise("");
    setMyFile("");
    setFileExtensionType("");
    setAccept("");
    setFileName("");
    setQuestionId("");
    setQuestion("");
    setOptionMediaType("");
    setQuestionMedia("");
    setQuestionMediaType("");
    setInstructions("");
    setCorrectOption([]);
    setHints("");
    setOptionA("");
    setOptionB("");
    setOptionC("");
    setOptionD("");
    setRearrangeSentenceArray([]);
    setRearrangeSentence("");
    setSelectedExercise("");
    setPuzzleQuestions([{ wordValue: "" }]);
    setSentenceRearrangements([{ wordValue: "" }]);
    setParagraphText("");
    setParagraphOptions([""]);
    setAnswers([]);
    setMatchingQuestions([{ ltype: "", left: "", rtype: "", right: "" }]);
    // reset();
  };
  //^------------------Save function for the Quiz---------------------

  // Check if all items in sentenceRearrangements have non-empty wordValue
  const hasValidWords = sentenceRearrangements.every(
    (item) => item?.wordValue?.trim() !== ""
  );

  //
  const hasValidWordsPuzzle = puzzleQuestions.every(
    (item) => item?.wordValue?.trim() !== ""
  );

  // const hasValidWordsForUpdate = updateData.sentenceRearrangements.every(
  //   (word) => word && word.trim() !== ""
  // );

  // const hasValidWordsPuzzleforUpdate = updateData.puzzleQuestions.every(
  //   (word) => word && word.trim() !== ""
  // );

  const handleSave = () => {
    setLoadingSave(true);

    if (!selectedExercise) {
      toast.error("Please select an exercise before proceeding");
      setLoadingSave(false);
    } else if (!question || question.trim() === "") {
      toast.error("Please add a question");
      setLoadingSave(false);
    } else if (selectedExercise === "selectFromMultiple") {
      if (!answerType) {
        toast.error(
          "Please select the answer type of the question before proceeding"
        );
        setLoadingSave(false);
      } else if (questionMediaType && !questionMedia) {
        toast.error("Please choose a question media before proceeding !");
        setLoadingSave(false);
      } else if (!optionMediaType) {
        toast.error(
          "Please select the media type for the options before proceeding"
        );
        setLoadingSave(false);
      } else if (!correctOption || correctOption.length === 0) {
        toast.error("You must have a correct option before proceeding");
        setLoadingSave(false);
      } else if (
        (answerType === "2options" &&
          (!optionA ||
            optionA.trim() === "" ||
            !optionB ||
            optionB.trim() === "")) ||
        (answerType === "3options" &&
          (!optionA ||
            optionA.trim() === "" ||
            !optionB ||
            optionB.trim() === "" ||
            !optionC ||
            optionC.trim() === "")) ||
        (answerType === "4options" &&
          (!optionA ||
            optionA.trim() === "" ||
            !optionB ||
            optionB.trim() === "" ||
            !optionC ||
            optionC.trim() === "" ||
            !optionD ||
            optionD.trim() === ""))
      ) {
        toast.error("Please fill all the options");
        setLoadingSave(false);
      } else {
        saveQuiz();
      }
    } else if (selectedExercise === "rearrangement") {
      if (sentenceRearrangements.length === 0 || !hasValidWords) {
        toast.error("Please add a word first!");
        setLoadingSave(false);
      } else if (sentenceRearrangements.length < 3 && hasValidWords) {
        toast.error("The number of words should be minimum 3");
        setLoadingSave(false);
      } else {
        saveQuiz();
      }
    } else if (selectedExercise === "puzzle") {
      if (puzzleQuestions.length === 0 || !hasValidWordsPuzzle) {
        toast.error("Please add a word first!");
        setLoadingSave(false);
      } else if (puzzleQuestions.length < 5 && hasValidWordsPuzzle) {
        toast.error("The number of words should be minimum 5");
        setLoadingSave(false);
      } else {
        saveQuiz();
      }
    } else if (selectedExercise === "matching") {
      if (matchingQuestions.length < 3) {
        toast.error("You must add at least 3 matching questions");
        setLoadingSave(false);
      } else if (
        matchingQuestions.some(
          (q) =>
            !q.ltype ||
            q.left.trim() === "" ||
            !q.rtype ||
            q.right.trim() === ""
        )
      ) {
        toast.error("Please ensure all matching questions have valid entries");
        setLoadingSave(false);
      } else {
        saveQuiz();
      }
    } else if (selectedExercise === "fillInBlanks") {
      if (!paragraphText || paragraphText.trim() === "") {
        toast.error("Please add the paragraph text");
        setLoadingSave(false);
      } else if (answers.length === 0) {
        toast.error("Please insert at least one blank");
        setLoadingSave(false);
      } else if (
        answers.some((answer) => !answer.answer || answer.answer.trim() === "")
      ) {
        toast.error("Please provide an answer for each blank");
        setLoadingSave(false);
      } else if (
        paragraphOptions.length === 0 ||
        paragraphOptions.some((option) => !option.trim())
      ) {
        toast.error("Please provide options for the paragraph");
        setLoadingSave(false);
      } else if (
        answers.some((answer) => !paragraphOptions.includes(answer.answer))
      ) {
        toast.error("Each answer must have a corresponding option");
        setLoadingSave(false);
      } else {
        saveQuiz();
      }
    }
  };

  console.log("opn a------------>", optionA);

  const saveQuiz = () => {
    const data = {
      topicId: selTopicDetails.topicId,
      quizType: "gamified",
      gamifiedData: [
        ...quizes,
        selectedExercise === "fillInBlanks"
          ? {
              questionId: new Date().getTime(),
              questionOrder: quizes?.length,
              question,
              questionMediaType,
              gameQuestionMedia: questionMedia.url,
              instructions,
              hints,
              gameType: selectedExercise,
              fillInBlanksArr: [
                {
                  text: paragraphText,
                  correctInput: answers,
                  options: paragraphOptions,
                },
              ],
            }
          : selectedExercise === "selectFromMultiple"
          ? {
              gameType: selectedExercise,
              hints,
              question,
              questionOrder: quizes?.length,
              instructions,
              questionId: new Date().getTime(),
              questionMediaType,
              gameQuestionMedia: questionMedia.url,
              correctAnswer: [
                {
                  optionA,
                  optionB,
                  optionC,
                  optionD,
                  optionMediaType,
                  correctOption,
                  answerType,
                },
              ],
            }
          : selectedExercise === "rearrangement"
          ? {
              gameType: selectedExercise,
              questionId: new Date().getTime(),
              questionOrder: quizes?.length,
              question,
              questionMediaType,
              gameQuestionMedia: questionMedia.url,
              instructions,
              hints,
              correctAnswer: sentenceRearrangements,
            }
          : selectedExercise === "puzzle"
          ? {
              gameType: selectedExercise,
              questionId: new Date().getTime(),
              questionOrder: quizes?.length,
              question,
              questionMediaType,
              gameQuestionMedia: questionMedia.url,
              instructions,
              hints,
              correctAnswer: puzzleQuestions,
            }
          : selectedExercise === "matching"
          ? {
              gameType: selectedExercise,
              questionId: new Date().getTime(),
              questionOrder: quizes?.length,
              question,
              questionMediaType,
              gameQuestionMedia: questionMedia.url,
              instructions,
              hints,
              correctAnswer: matchingQuestions,
            }
          : {},
      ],
    };

    console.log("body sent for saving------------------>", data);
    saveGamifiedQuiz(data)
      .then((res) => {
        if (res.status === 200) {
          toast.success("Quiz saved successfully!");
          setLoadingSave(false);
          getAllGamifiedQuizzes(selTopicDetails.topicId)
            .then((res) => {
              if (res.status === 200) {
                setQuizes(res.data);
                resetAll();
                handleClose();
              } else if (res.status === 204) {
                toast.info("No data is there to display!");
              } else {
                toast.info("Please try again later.");
                console.log(
                  "response status while receiving gamified quizzes--------------------->",
                  res.status
                );
              }
            })
            .catch((error) => {
              if (error.response) {
                if (error.response.status === 500) {
                  console.error(
                    "The error while fetching gamified Quiz------------------------->",
                    error
                  );
                } else if (error.response.status === 504) {
                  console.error(
                    "The error while fetching gamified Quiz------------------------->",
                    error
                  );
                } else {
                  console.error(
                    "The error while fetching gamified Quiz------------------------->",
                    error
                  );
                }
              } else {
                toast.error(
                  "Some internal error occurred. Please try again later."
                );
                console.error(
                  "The error while saving gamified Quiz------------------------->",
                  error
                );
              }
            });
        } else {
          toast.error("Sorry, something went wrong. Please try again later.");
          console.log(
            "Status code while saving quiz--------------->",
            res.status
          );
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 500) {
            toast.error("Internal server error. Please try again later.");
            console.error(
              "The error while saving gamified Quiz------------------------->",
              error
            );
          } else if (error.response.status === 504) {
            toast.error("Server timeout error. Please try again later.");
            console.error(
              "The error while saving gamified Quiz------------------------->",
              error
            );
          } else {
            toast.error(
              "An unexpected error occurred. Please try again later."
            );
            console.error(
              "The error while saving gamified Quiz------------------------->",
              error
            );
          }
        }
        setLoadingSave(false);
      });
  };

  //^------------------------------------------------------------------------

  //?--------------This contains the states and the functionalities for editing the quiz--------------------------------------------
  const [showUpdate, setShowUpdate] = useState(false);
  const [updateData, setUpdateData] = useState({
    questionOrder: "",
    questionId: "",
    question: "",
    questionMediaType: "",
    gameQuestionMedia: "",
    instructions: "",
    hints: "",
    gameType: "",
    correctAnswer: [],
    fillInBlanksArr: [],
  });

  const handleUpdateChange = (event) => {
    const { name, value } = event.target;

    setUpdateData((prevData) => ({
      ...prevData,
      [name]: value,
      correctAnswer: [], // Reset correctAnswer when changing game type
    }));

    // If needed, reset other fields based on game type
    if (value === "selectFromMultiple") {
      setUpdateData((prevData) => ({
        ...prevData,
        optionA: "",
        optionB: "",
        optionC: "",
        optionD: "",
        correctOption: [],
      }));
    } else if (
      value === "rearrangement" ||
      value === "puzzle" ||
      value === "matching"
    ) {
      setUpdateData((prevData) => ({
        ...prevData,
        correctAnswer: [],
      }));
    } else if (value === "fillInBlanks") {
      setUpdateData((prevData) => ({
        ...prevData,
        fillInBlanksArr: [], // Example for fill in the blanks type
      }));
    }
  };

  const answer_type_list =
    optionMediaType === "text" ||
    updateData?.correctAnswer[0]?.optionMediaType === "text"
      ? [
          { value: "yesNoOptions", label: "Yes/ No" },
          { value: "2options", label: "2 Options" },
          { value: "3options", label: "3 Options" },
          { value: "4options", label: "4 Options" },
        ]
      : [
          { value: "2options", label: "2 Options" },
          { value: "3options", label: "3 Options" },
          { value: "4options", label: "4 Options" },
        ];

  const answer_media_list = [
    { value: "text", label: "Text" },
    { value: "image", label: "Image" },
    { value: "audio", label: "Audio" },
  ];

  const handleShowUpdate = (item) => {
    setShowUpdate(true);
    const newUpdateData = {
      questionOrder: item.questionOrder,
      questionId: item.questionId,
      question: item.question,
      questionMediaType: item.questionMediaType,
      gameQuestionMedia: item.gameQuestionMedia,
      instructions: item.instructions,
      hints: item.hints,
      gameType: item.gameType,
      correctAnswer: item.correctAnswer,
      fillInBlanksArr: item.fillInBlanksArr,
    };
    setUpdateData(newUpdateData);

    // Determine which options to show based on the answer type (This will be for selectFromMultiple)
    if (
      item.gameType === "selectFromMultiple" &&
      item.correctAnswer[0].answerType === "2options"
    ) {
      setShowOptions2(true);
      setShowOptions3(false);
      setShowOptions4(false);
      setShowOptionsYN(false);
    } else if (
      item.gameType === "selectFromMultiple" &&
      item.correctAnswer[0].answerType === "3options"
    ) {
      setShowOptions2(false);
      setShowOptions3(true);
      setShowOptions4(false);
      setShowOptionsYN(false);
    } else if (
      item.gameType === "selectFromMultiple" &&
      item.correctAnswer[0].answerType === "4options"
    ) {
      setShowOptions2(false);
      setShowOptions3(false);
      setShowOptions4(true);
      setShowOptionsYN(false);
    } else {
      setShowOptions2(false);
      setShowOptions3(false);
      setShowOptions4(false);
      setShowOptionsYN(true);
    }
  };

  const updateQuiz = () => {
    setLoadingUpdate(true);

    // Validation checks for different exercises
    if (!updateData?.gameType) {
      toast.error("Please select an exercise before proceeding");
      setLoadingUpdate(false);
    } else if (!updateData.question || updateData.question.trim() === "") {
      toast.error("Please add a question");
      setLoadingUpdate(false);
    } else if (updateData?.gameType === "selectFromMultiple") {
      if (!updateData.correctAnswer[0]?.answerType) {
        toast.error(
          "Please select the answer type of the question before proceeding"
        );
        setLoadingUpdate(false);
      } else if (!updateData.correctAnswer[0]?.optionMediaType) {
        toast.error(
          "Please select the media type for the options before proceeding"
        );
        setLoadingUpdate(false);
      } else if (
        updateData?.questionMediaType &&
        !updateData?.gameQuestionMedia
      ) {
        toast.error("Please select a question media before proceeding");
        setLoadingUpdate(false);
      } else if (
        !updateData.correctAnswer ||
        updateData.correctAnswer.length === 0
      ) {
        toast.error("You must have a correct option before proceeding");
        setLoadingUpdate(false);
      } else if (
        (updateData.correctAnswer[0]?.answerType === "2options" &&
          (!updateData.correctAnswer[0]?.optionA ||
            updateData.correctAnswer[0]?.optionA.trim() === "" ||
            !updateData.correctAnswer[0]?.optionB ||
            updateData.correctAnswer[0]?.optionB.trim() === "")) ||
        (updateData.correctAnswer[0]?.answerType === "3options" &&
          (!updateData.correctAnswer[0]?.optionA ||
            updateData.correctAnswer[0]?.optionA.trim() === "" ||
            !updateData.correctAnswer[0]?.optionB ||
            updateData.correctAnswer[0]?.optionB.trim() === "" ||
            !updateData.correctAnswer[0]?.optionC ||
            updateData.correctAnswer[0]?.optionC.trim() === "")) ||
        (updateData.correctAnswer[0]?.answerType === "4options" &&
          (!updateData.correctAnswer[0]?.optionA ||
            updateData.correctAnswer[0]?.optionA.trim() === "" ||
            !updateData.correctAnswer[0]?.optionB ||
            updateData.correctAnswer[0]?.optionB.trim() === "" ||
            !updateData.correctAnswer[0]?.optionC ||
            updateData.correctAnswer[0]?.optionC.trim() === "" ||
            !updateData.correctAnswer[0]?.optionD ||
            updateData.correctAnswer[0]?.optionD.trim() === ""))
      ) {
        toast.error("Please fill all the options");
        setLoadingUpdate(false);
      } else {
        updateQuizData(); // Call API here
      }
    } else if (updateData?.gameType === "rearrangement") {
      // Check if the correctAnswer array is empty
      if (updateData.correctAnswer.length === 0) {
        toast.error("Please add a word first!");
        setLoadingUpdate(false);
      }
      // Check if any wordValue in correctAnswer is missing or invalid
      else if (
        updateData.correctAnswer.some(
          (answer) => !answer.wordValue || answer.wordValue.trim() === ""
        )
      ) {
        toast.error(
          "Some words are missing or invalid, please fill all words."
        );
        setLoadingUpdate(false);
      }
      // Check if there are fewer than 3 words
      else if (updateData.correctAnswer.length < 3) {
        toast.error("The number of words should be a minimum of 3.");
        setLoadingUpdate(false);
      }
      // If everything is valid, proceed to update
      else {
        updateQuizData();
      }
    } else if (updateData?.gameType === "puzzle") {
      // Check if the correctAnswer array is empty
      if (updateData?.correctAnswer?.length === 0) {
        toast.error("Please add a word first!");
        setLoadingUpdate(false);
      }
      // Check if any wordValue in correctAnswer is missing or invalid
      else if (
        updateData?.correctAnswer.some(
          (answer) => !answer.wordValue || answer.wordValue.trim() === ""
        )
      ) {
        toast.error(
          "Some puzzle words are missing or invalid, please fill all words."
        );
        setLoadingUpdate(false);
      }
      // Check if there are fewer than 3 words
      else if (updateData.correctAnswer.length < 5) {
        toast.error("The number of words should be a minimum of 5.");
        setLoadingUpdate(false);
      }
      // If everything is valid, proceed to update
      else {
        updateQuizData();
      }
    } else if (updateData?.gameType === "matching") {
      if (updateData.matchingQuestions.length < 3) {
        toast.error("You must add at least 3 matching questions");
        setLoadingUpdate(false);
      } else if (
        updateData.matchingQuestions.some(
          (q) =>
            !q.ltype ||
            q.left.trim() === "" ||
            !q.rtype ||
            q.right.trim() === ""
        )
      ) {
        toast.error("Please ensure all matching questions have valid entries");
        setLoadingUpdate(false);
      } else {
        updateQuizData(); // Call API here
      }
    } else if (updateData?.gameType === "fillInBlanks") {
      // Check if the paragraph text is present and not empty
      const paragraphObject = updateData?.fillInBlanksArr?.find(
        (obj) => obj.text
      );
      if (!paragraphObject?.text || paragraphObject.text.trim() === "") {
        toast.error("Please add the paragraph text");
        setLoadingUpdate(false);
      }
      // Check if there are any blanks in the fillInBlanksArr
      else if (updateData?.fillInBlanksArr.length === 0) {
        toast.error("Please insert at least one blank");
        setLoadingUpdate(false);
      }
      // Check if all answers are provided for each blank
      else if (
        updateData?.fillInBlanksArr.some((item) =>
          item.correctInput.some(
            (answer) => !answer.answer || answer.answer.trim() === ""
          )
        )
      ) {
        toast.error("Please provide an answer for each blank");
        setLoadingUpdate(false);
      }
      // Check if options array is present, not empty, and all options are valid
      else if (
        updateData?.fillInBlanksArr.some(
          (item) =>
            !item.options ||
            item.options.length === 0 ||
            item.options.some((option) => !option || !option.trim())
        )
      ) {
        toast.error("Please provide options for the paragraph");
        setLoadingUpdate(false);
      }
      // Check if each answer has a corresponding option
      else if (
        updateData?.fillInBlanksArr.some((item) =>
          item.correctInput.some(
            (answer) => !item.options.includes(answer.answer)
          )
        )
      ) {
        toast.error("Each answer must have a corresponding option");
        setLoadingUpdate(false);
      } else {
        updateQuizData(); // Call API here
      }
    }
  };

  // Function to update the quiz data after validation
  const updateQuizData = () => {
    const newData = quizes.map((item) => {
      if (item.questionId === updateData.questionId) {
        return {
          ...item,
          questionOrder: updateData.questionOrder,
          question: updateData.question,
          questionMediaType: updateData.questionMediaType,
          gameQuestionMedia: updateData.gameQuestionMedia,
          instructions: updateData.instructions,
          hints: updateData.hints,
          gameType: updateData.gameType,
          correctAnswer: updateData.correctAnswer,
          fillInBlanksArr: updateData.fillInBlanksArr,
        };
      }
      return item;
    });

    const data = {
      topicId: selTopicDetails.topicId,
      quizType: "gamified",
      gamifiedData: newData,
    };

    updateGamifiedQuiz(data)
      .then((res) => {
        if (res.status === 200) {
          toast.success("Question updated successfully!");
          setShowUpdate(false);
          getAllGamifiedQuizzes(selTopicDetails.topicId)
            .then((res) => {
              if (res.status === 200) {
                setQuizes(res.data);
                resetAll();
                setLoadingUpdate(false);
                handleClose();
              } else if (res.status === 204) {
                toast.info("No data is there to display!");
                setLoadingUpdate(false);
              }
            })
            .catch((error) => {
              handleApiError(error, "fetching gamified quizzes");
            });
        } else {
          toast.error(
            "Sorry, couldn't update due to internal issues. Please try again later."
          );
        }
      })
      .catch((error) => {
        handleApiError(error, "updating gamified quiz");
      });
  };

  // Utility function to handle API errors
  const handleApiError = (error, context) => {
    if (error.response) {
      if (error.response.status === 500) {
        toast.error("Internal server error. Please try again later.");
        console.error(
          `The error while ${context}------------------------->`,
          error
        );
      } else if (error.response.status === 504) {
        toast.error("Server timeout error. Please try again later.");
        console.error(
          `The error while ${context}------------------------->`,
          error
        );
      } else {
        toast.error("An unexpected error occurred. Please try again later.");
        console.error(
          `The error while ${context}------------------------->`,
          error
        );
      }
    } else {
      toast.error("Some internal error occurred. Please try again later.");
      console.error(
        `The error while ${context}------------------------->`,
        error
      );
    }
    setLoadingUpdate(false);
  };

  const handleCloseUpdate = () => {
    setShowUpdate(false);
    setSelectedFile(null);
    setMyFile("");
    setFileExtensionType("");
    setAccept("");
    setFileName("");
    setQuestionId("");
    setQuestion("");
    setOptionMediaType("");
    setQuestionMedia("");
    setQuestionMediaType("");
    setInstructions("");
    setCorrectOption([]);
    setHints("");
    setOptionA("");
    setOptionB("");
    setOptionC("");
    setOptionD("");
    setLoadingUpdate(false);
  };

  //?-----------------------------------------------------------------------------------------------------------------------------------------

  const close_quiz_dialog = () => {
    resetAll();
    // setShow(false);
    handleClose();
  };

  const [matchingQuestions, setMatchingQuestions] = useState([
    { ltype: "", left: "", rtype: "", right: "" },
  ]);

  const handleAddQuestion = () => {
    const lastQuestion = matchingQuestions[matchingQuestions.length - 1];
    if (!lastQuestion.left || !lastQuestion.right) {
      alert(
        "Please add both left and right values before adding a new question."
      );
      return;
    }
    setMatchingQuestions([
      ...matchingQuestions,
      { ltype: "", left: "", rtype: "", right: "" },
    ]);
  };

  const handleRemoveQuestion = (index) => {
    if (matchingQuestions.length > 1) {
      const updatedQuestions = matchingQuestions.filter((_, i) => i !== index);
      setMatchingQuestions(updatedQuestions);
    }
  };

  const handleChangeQuestionType = (index, side, type) => {
    const updatedQuestions = matchingQuestions.map((q, i) =>
      i === index ? { ...q, [side]: type } : q
    );
    setMatchingQuestions(updatedQuestions);
  };

  const handleChangeQuestionValue = (index, side, value) => {
    const updatedQuestions = matchingQuestions.map((q, i) =>
      i === index ? { ...q, [side]: value } : q
    );
    setMatchingQuestions(updatedQuestions);
  };

  const renderQuestionInputs = (question, index, side) => (
    <>
      <FormControl fullWidth size="small" sx={{ mb: 2 }}>
        <InputLabel>
          {side === "left" ? "Left Column" : "Right Column"}
        </InputLabel>
        <Select
          value={question[side === "left" ? "ltype" : "rtype"]}
          label="Type"
          onChange={(e) =>
            handleChangeQuestionType(
              index,
              side === "left" ? "ltype" : "rtype",
              e.target.value
            )
          }
          sx={{ mt: 1 }}
        >
          <MenuItem value="text">Text</MenuItem>
          {/* <MenuItem value="image">Image</MenuItem> */}
        </Select>
      </FormControl>
      {question[side === "left" ? "ltype" : "rtype"] === "text" ? (
        <TextField
          value={question[side === "left" ? "left" : "right"]}
          onChange={(e) =>
            handleChangeQuestionValue(
              index,
              side === "left" ? "left" : "right",
              e.target.value
            )
          }
          placeholder="Enter text"
          fullWidth
          sx={{ mb: 2 }}
        />
      ) : question[side === "left" ? "ltype" : "rtype"] === "image" ? (
        <>
          <input
            type="file"
            accept="image/*"
            onChange={(e) =>
              handleChangeQuestionValue(
                index,
                side === "left" ? "left" : "right",
                URL.createObjectURL(e.target.files[0])
              )
            }
            style={{ display: "none" }}
            id={`upload-file-${index}-${side}`}
          />
          <label htmlFor={`upload-file-${index}-${side}`}>Upload Image</label>
          {question[side === "left" ? "left" : "right"] && (
            <img
              src={question[side === "left" ? "left" : "right"]}
              alt="Preview"
              style={{ width: "100px", marginTop: "8px" }}
            />
          )}
        </>
      ) : null}
    </>
  );

  const handleAddPuzzleQuestion = () => {
    // Check if the last text field is empty after trimming spaces
    if (puzzleQuestions[puzzleQuestions.length - 1].wordValue.trim() === "") {
      toast.error(
        "Please fill the current text field before adding a new one."
      );
      return;
    }

    setPuzzleQuestions([...puzzleQuestions, { wordValue: "" }]);
  };
  const handleRemovePuzzleQuestion = (index) => {
    if (puzzleQuestions.length > 1) {
      const updatedPuzzleQuestions = puzzleQuestions.filter(
        (_, i) => i !== index
      );
      setPuzzleQuestions(updatedPuzzleQuestions);
    }
  };

  const handlePuzzleQuestionChange = (index, event) => {
    const newPuzzleQuestions = [...puzzleQuestions];
    newPuzzleQuestions[index].wordValue = event.target.value.trim();
    newPuzzleQuestions[index].wordOrder = newPuzzleQuestions.length;
    newPuzzleQuestions[index].correctStatus = true;
    newPuzzleQuestions[index].wordId = new Date().getTime();
    setSentenceRearrangements(newPuzzleQuestions);
    setPuzzleQuestions(newPuzzleQuestions);
  };

  const handleSentenceRearrangementChange = (index, event) => {
    const newSentenceRearrangements = [...sentenceRearrangements];
    // Remove spaces from the input value
    const inputValue = event.target.value.replace(/\s+/g, "").trim();

    newSentenceRearrangements[index].wordValue = inputValue;
    newSentenceRearrangements[index].wordOrder =
      newSentenceRearrangements.length;
    newSentenceRearrangements[index].correctStatus = true;
    newSentenceRearrangements[index].wordId = new Date().getTime();

    setSentenceRearrangements(newSentenceRearrangements);
  };

  console.log("sentenceRearrangements------------>", sentenceRearrangements);

  const handleAddSentenceRearrangement = () => {
    if (
      sentenceRearrangements[
        sentenceRearrangements.length - 1
      ].wordValue.trim() === ""
    ) {
      toast.error(
        "Please fill the current text field before adding a new one."
      );
      return;
    }

    setSentenceRearrangements([...sentenceRearrangements, { wordValue: "" }]);
  };

  const handleRemoveSentenceRearrangement = (index) => {
    const newSentenceRearrangements = sentenceRearrangements.filter(
      (_, i) => i !== index
    );
    setSentenceRearrangements(newSentenceRearrangements);
  };

  const handleBlankInsert = () => {
    // Insert a blank at the end of the paragraph text
    const newParagraphText = paragraphText + "__________";
    setParagraphText(newParagraphText);

    // Add a new answer field for the newly inserted blank
    setAnswers([...answers, { blank: answers.length + 1, answer: "" }]);
  };

  const handleParagraphTextChange = (value) => {
    const prevText = paragraphText;
    const blankString = "__________";

    // Check if the user is backspacing over a blank
    if (prevText.endsWith(blankString) && value.length < prevText.length) {
      // Find the last occurrence of the blank and remove it entirely
      const lastBlankIndex = prevText.lastIndexOf(blankString);

      // If the lastBlankIndex is at the end of the text, remove the entire blank
      if (
        lastBlankIndex >= 0 &&
        lastBlankIndex + blankString.length === prevText.length
      ) {
        const updatedText = prevText.slice(0, lastBlankIndex).trim();
        setParagraphText(updatedText);

        // Also, remove the corresponding answer for the removed blank
        const updatedAnswers = answers.slice(0, answers.length - 1); // Remove the last answer
        setAnswers(updatedAnswers);
        return;
      }
    }

    // Process normal input change
    const prevBlanks = prevText.split(blankString).length - 1;
    const newBlanks = value.split(blankString).length - 1;

    // Determine if blanks were removed
    if (newBlanks < prevBlanks) {
      // Remove answers for the removed blanks
      const updatedAnswers = answers.filter(
        (answer) => answer.blank <= newBlanks
      );

      // Adjust blank numbering for remaining answers
      const reIndexedAnswers = updatedAnswers.map((answer, index) => ({
        ...answer,
        blank: index + 1,
      }));

      setAnswers(reIndexedAnswers);
    } else if (newBlanks > prevBlanks) {
      // Add answers for newly inserted blanks
      const newAnswers = Array.from(
        { length: newBlanks - prevBlanks },
        (_, i) => ({
          blank: answers.length + i + 1,
          answer: "",
        })
      );

      setAnswers([...answers, ...newAnswers]);
    }

    setParagraphText(value);
  };

  const handleParagraphOptionChange = (index, value) => {
    const updatedOptions = [...paragraphOptions];
    updatedOptions[index] = value;
    setParagraphOptions(updatedOptions);
  };

  const handleAddParagraphOption = () => {
    setParagraphOptions([...paragraphOptions, ""]);
  };

  const handleRemoveParagraphOption = (index) => {
    const updatedOptions = [...paragraphOptions];
    updatedOptions.splice(index, 1);
    setParagraphOptions(updatedOptions);
  };

  const handleAnswerChange = (index, value) => {
    const updatedAnswers = [...answers];
    updatedAnswers[index].answer = value;
    setAnswers(updatedAnswers);
  };

  //udpate functions-------------------------------------------------------------------------------------------------

  const handleUpdateAddQuestion = () => {
    setUpdateData((prevData) => ({
      ...prevData,
      correctAnswer: [
        ...prevData.correctAnswer,
        { ltype: "", left: "", rtype: "", right: "", correctStatus: true },
      ],
    }));
  };

  const handleUpdateRemoveQuestion = (index) => {
    setUpdateData((prevData) => ({
      ...prevData,
      correctAnswer: prevData.correctAnswer.filter((_, i) => i !== index),
    }));
  };

  const handleUpdateChangeQuestionType = (index, side, type) => {
    setUpdateData((prevData) => ({
      ...prevData,
      correctAnswer: prevData.correctAnswer.map((q, i) =>
        i === index ? { ...q, [side === "left" ? "ltype" : "rtype"]: type } : q
      ),
    }));
  };

  const handleUpdateChangeQuestionValue = (index, side, value) => {
    setUpdateData((prevData) => ({
      ...prevData,
      correctAnswer: prevData.correctAnswer.map((q, i) =>
        i === index ? { ...q, [side === "left" ? "left" : "right"]: value } : q
      ),
    }));
  };

  const renderUpdateQuestionInputs = (question, index, side) => (
    <>
      <FormControl fullWidth size="small" sx={{ mb: 2 }}>
        <InputLabel>
          {side === "left" ? "Left Column" : "Right Column"}
        </InputLabel>
        <Select
          value={question[side === "left" ? "ltype" : "rtype"]}
          label="Type"
          onChange={(e) =>
            handleUpdateChangeQuestionType(index, side, e.target.value)
          }
          sx={{ mt: 1 }}
        >
          <MenuItem value="text">Text</MenuItem>
          {/* <MenuItem value="image">Image</MenuItem> */}
        </Select>
      </FormControl>
      {question[side === "left" ? "ltype" : "rtype"] === "text" ? (
        <TextField
          value={question[side === "left" ? "left" : "right"] || ""}
          onChange={(e) =>
            handleUpdateChangeQuestionValue(index, side, e.target.value)
          }
          placeholder="Enter text"
          fullWidth
          sx={{ mb: 2 }}
        />
      ) : question[side === "left" ? "ltype" : "rtype"] === "image" ? (
        <>
          <input
            type="file"
            accept="image/*"
            onChange={(e) =>
              handleUpdateChangeQuestionValue(
                index,
                side,
                URL.createObjectURL(e.target.files[0])
              )
            }
            style={{ display: "none" }}
            id={`upload-file-${index}-${side}`}
          />
          <label htmlFor={`upload-file-${index}-${side}`}>Upload Image</label>
          {question[side === "left" ? "left" : "right"] && (
            <img
              src={question[side === "left" ? "left" : "right"]}
              alt="Preview"
              style={{ width: "100px", marginTop: "8px" }}
            />
          )}
        </>
      ) : null}
    </>
  );

  const handleUpdateSentenceRearrangementChange = (index, event) => {
    setUpdateData((prevData) => {
      const newSentenceRearrangements = [...prevData.correctAnswer];
      newSentenceRearrangements[index] = {
        ...newSentenceRearrangements[index],
        wordValue: event.target.value.trim(),
        wordOrder: newSentenceRearrangements.length,
        correctStatus: true,
        wordId: new Date().getTime(),
      };
      return { ...prevData, correctAnswer: newSentenceRearrangements };
    });
  };

  const handleUpdateAddSentenceRearrangement = () => {
    setUpdateData((prevData) => {
      const newSentenceRearrangements = [...prevData?.correctAnswer];
      if (
        newSentenceRearrangements[
          newSentenceRearrangements.length - 1
        ].wordValue.trim() === ""
      ) {
        toast.error(
          "Please fill the current text field before adding a new one."
        );
        return prevData;
      }
      newSentenceRearrangements.push({ wordValue: "" });
      return { ...prevData, correctAnswer: newSentenceRearrangements };
    });
  };

  const handleUpdateRemoveSentenceRearrangement = (index) => {
    setUpdateData((prevData) => {
      if (prevData.correctAnswer.length > 2) {
        const newSentenceRearrangements = prevData.correctAnswer.filter(
          (_, i) => i !== index
        );
        return { ...prevData, correctAnswer: newSentenceRearrangements };
      } else {
        toast.error("There must be a minimum of 2 words !");
        return prevData;
      }
    });
  };

  const handleUpdateAddPuzzleQuestion = () => {
    setUpdateData((prevData) => {
      const newPuzzleQuestions = [...prevData?.correctAnswer];
      if (
        newPuzzleQuestions[newPuzzleQuestions.length - 1].wordValue.trim() ===
        ""
      ) {
        toast.error(
          "Please fill the current text field before adding a new one."
        );
        return prevData;
      }
      newPuzzleQuestions.push({ wordValue: "" });
      return { ...prevData, correctAnswer: newPuzzleQuestions };
    });
  };

  const handleUpdateRemovePuzzleQuestion = (index) => {
    setUpdateData((prevData) => {
      if (prevData.correctAnswer.length > 2) {
        const newPuzzleQuestions = prevData.correctAnswer.filter(
          (_, i) => i !== index
        );
        return { ...prevData, correctAnswer: newPuzzleQuestions };
      } else {
        toast.error("The minimum word number for puzzle is 2 !");
        return prevData;
      }
    });
  };

  const handleUpdatePuzzleQuestionChange = (index, event) => {
    setUpdateData((prevData) => {
      const newPuzzleQuestions = [...prevData.correctAnswer];
      newPuzzleQuestions[index] = {
        ...newPuzzleQuestions[index],
        wordValue: event.target.value.trim(),
        wordOrder: newPuzzleQuestions.length,
        correctStatus: true,
        wordId: new Date().getTime(),
      };
      return { ...prevData, correctAnswer: newPuzzleQuestions }; //
    });
  };

  const handleUpdateBlankInsert = (index) => {
    const newParagraphText =
      updateData.fillInBlanksArr[index].text + "__________";

    setUpdateData((prevData) => {
      const updatedFillInBlanksArr = [...prevData.fillInBlanksArr];
      updatedFillInBlanksArr[index] = {
        ...updatedFillInBlanksArr[index],
        text: newParagraphText,
        correctInput: [
          ...updatedFillInBlanksArr[index].correctInput,
          {
            blank: updatedFillInBlanksArr[index].correctInput.length + 1,
            answer: "",
          },
        ],
      };

      return { ...prevData, fillInBlanksArr: updatedFillInBlanksArr };
    });
  };

  const handleUpdateParagraphTextChange = (value, index) => {
    const blankString = "__________";
    const prevText = updateData.fillInBlanksArr[index].text;
    const prevAnswers = [...updateData.fillInBlanksArr[index].correctInput];

    // If user is backspacing over a blank
    if (prevText.length > value.length && prevText.endsWith(blankString)) {
      const lastBlankIndex = prevText.lastIndexOf(blankString);
      const updatedText = prevText.slice(0, lastBlankIndex).trim();

      // Remove the corresponding answer for the removed blank
      const updatedAnswers = prevAnswers.slice(0, prevAnswers.length - 1); // Remove the last answer

      // Update state with the modified text and answer array
      setUpdateData((prevData) => {
        const updatedFillInBlanksArr = [...prevData.fillInBlanksArr];
        updatedFillInBlanksArr[index] = {
          ...updatedFillInBlanksArr[index],
          text: updatedText,
          correctInput: updatedAnswers,
        };

        return { ...prevData, fillInBlanksArr: updatedFillInBlanksArr };
      });
      return;
    }

    // Track the positions of blanks in both previous and current text
    const prevBlankPositions = [];
    const newBlankPositions = [];

    // Find all occurrences of blankString in the previous text
    let lastIndex = 0;
    while ((lastIndex = prevText.indexOf(blankString, lastIndex)) !== -1) {
      prevBlankPositions.push(lastIndex);
      lastIndex += blankString.length;
    }

    // Find all occurrences of blankString in the new text
    lastIndex = 0;
    while ((lastIndex = value.indexOf(blankString, lastIndex)) !== -1) {
      newBlankPositions.push(lastIndex);
      lastIndex += blankString.length;
    }

    // Handle blank removal (if a blank is removed from the middle)
    let updatedAnswers = [...prevAnswers];
    if (newBlankPositions.length < prevBlankPositions.length) {
      // Find which blank was removed based on the difference in positions
      for (let i = 0; i < prevBlankPositions.length; i++) {
        if (prevBlankPositions[i] !== newBlankPositions[i]) {
          // Remove the corresponding answer for the removed blank
          updatedAnswers.splice(i, 1); // Remove the answer at the same index as the removed blank
          break;
        }
      }
    }

    // Handle adding new blanks (if blanks are added)
    if (newBlankPositions.length > prevBlankPositions.length) {
      const newBlanksToAdd =
        newBlankPositions.length - prevBlankPositions.length;
      const newAnswers = Array.from({ length: newBlanksToAdd }, (_, i) => ({
        blank: updatedAnswers.length + i + 1,
        answer: "",
      }));
      updatedAnswers = [...updatedAnswers, ...newAnswers];
    }

    // Update the state with the modified text and answer array
    setUpdateData((prevData) => {
      const updatedFillInBlanksArr = [...prevData.fillInBlanksArr];

      updatedFillInBlanksArr[index] = {
        ...updatedFillInBlanksArr[index],
        text: value,
        correctInput: updatedAnswers,
      };

      return { ...prevData, fillInBlanksArr: updatedFillInBlanksArr };
    });
  };

  const handleUpdateAnswerChange = (questionIndex, answerIndex, value) => {
    const updatedFillInBlanksArr = [...updateData.fillInBlanksArr];
    const updatedAnswers = [
      ...updatedFillInBlanksArr[questionIndex].correctInput,
    ];

    updatedAnswers[answerIndex] = {
      ...updatedAnswers[answerIndex],
      answer: value,
    };
    updatedFillInBlanksArr[questionIndex].correctInput = updatedAnswers;

    setUpdateData((prevData) => ({
      ...prevData,
      fillInBlanksArr: updatedFillInBlanksArr,
    }));
  };

  const handleUpdateParagraphOptionChange = (
    questionIndex,
    optionIndex,
    value
  ) => {
    const updatedFillInBlanksArr = [...updateData.fillInBlanksArr];
    const updatedOptions = [...updatedFillInBlanksArr[questionIndex].options];

    updatedOptions[optionIndex] = value;
    updatedFillInBlanksArr[questionIndex].options = updatedOptions;

    setUpdateData((prevData) => ({
      ...prevData,
      fillInBlanksArr: updatedFillInBlanksArr,
    }));
  };

  const handleUpdateAddParagraphOption = (index) => {
    setUpdateData((prevData) => {
      const updatedFillInBlanksArr = [...prevData.fillInBlanksArr];
      const updatedOptions = [...updatedFillInBlanksArr[index].options, ""];
      updatedFillInBlanksArr[index].options = updatedOptions;

      return { ...prevData, fillInBlanksArr: updatedFillInBlanksArr };
    });
  };

  const handleUpdateRemoveParagraphOption = (questionIndex, optionIndex) => {
    setUpdateData((prevData) => {
      const updatedFillInBlanksArr = [...prevData.fillInBlanksArr];
      const updatedOptions = [...updatedFillInBlanksArr[questionIndex].options];

      updatedOptions.splice(optionIndex, 1);
      updatedFillInBlanksArr[questionIndex].options = updatedOptions;

      return { ...prevData, fillInBlanksArr: updatedFillInBlanksArr };
    });
  };

  //todo-------------------Console logs--------------------------------------
  // console.log("question---------------------------------->", question); //^----While uploading our questions
  // console.log("hints------------------------------>", hints); //^----while setting hints
  // console.log(
  //   "questionMediaType--------------------------->",
  //   questionMediaType
  // ); //^-----While setting the question media (image, video or audio)
  // console.log("instructions---------------------->", instructions); //^----While setting instructions
  // console.log("optionMediaType----------------------------->", optionMediaType); //^----While setting the answer media
  // console.log("answerType------------------------------->", answerType); //^---While setting the Quiz type (2/3/4 or YN options)
  // console.log("myFile------------------------------------->", myFile);
  // console.log("correct answer----------------------->", correctOption); //^----While choosing the correct options
  // console.log("optionA-------------------------------->", optionA);
  // console.log("optionB-------------------------------->", optionB);
  // console.log("optionC-------------------------------->", optionC);
  // console.log("optionD-------------------------------->", optionD);
  // console.log("quizData---------------------------->", quizData);
  // console.log("quizes------------------------------------->", quizes); //^-------To store the data fetched
  // console.log("questionMedia------------------------------>", questionMedia);
  console.log("updateData---------------------->", updateData);
  // console.log("accept----------------------------->", accept);
  // console.log(
  //   "updateData QuestionMedia---------------------->",
  //   updateData.questionMedia
  // );

  return (
    <div>
      <div className="header-div">
        <MuiHeader header="Gamified Module" />
        <div style={{ display: "flex", marginLeft: "100px" }}>
          <Grid item>
            <FormControl
              sx={{ m: 1 }}
              style={{ width: "130px", marginLeft: "-64px" }}
              size="small"
            >
              <InputLabel id="demo-select-small">Language</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={preferedlanguage}
                label="Language" //
                onChange={preflanguage_select_onchange}
              >
                <MenuItem value="">None</MenuItem>
                {language_select_option_list.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item>
            <FormControl sx={{ m: 1 }} style={{ width: "130px" }} size="small">
              <InputLabel id="demo-select-small">Usertype</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={usertype}
                label="Usertype"
                onChange={usertype_select_onchange}
              >
                <MenuItem value="">None</MenuItem>
                {usertype_select_option_list.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item>
            <FormControl sx={{ m: 1 }} style={{ width: "150px" }} size="small">
              <InputLabel id="demo-select-small">Trainingtype</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={programtype}
                label="Trainingtype"
                onChange={program_select_onchange}
              >
                <MenuItem value="">None</MenuItem>
                {trainingTypeArray.map((option) => (
                  <MenuItem
                    key={option.trainingType}
                    value={option.trainingType}
                  >
                    {option.trainingName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item>
            <FormControl sx={{ m: 1 }} style={{ width: "130px" }} size="small">
              <InputLabel id="demo-select-small">Module</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={selModuleDetails}
                label="Module"
                onChange={module_select_onchange}
              >
                <MenuItem value="">None</MenuItem>
                {usertype && programtype && Array.isArray(modules)
                  ? modules.map(
                      (
                        option //
                      ) => (
                        <MenuItem key={option.moduleId} value={option.moduleId}>
                          {option.moduleName}
                        </MenuItem>
                      )
                    )
                  : null}
              </Select>
            </FormControl>
          </Grid>
          <Grid item>
            <FormControl sx={{ m: 1 }} style={{ width: "140px" }} size="small">
              <InputLabel id="demo-select-small">Sub-Module</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={selSubModuleDetails}
                label="Submodule"
                onChange={submodule_select_onchange}
              >
                <MenuItem value="">None</MenuItem>
                {usertype &&
                usertype != "" &&
                programtype &&
                Array.isArray(subModules)
                  ? subModules.map((option) => (
                      <MenuItem
                        key={option.submoduleId}
                        value={option.submoduleId}
                      >
                        {option.submoduleName}
                      </MenuItem>
                    ))
                  : null}
              </Select>
            </FormControl>
          </Grid>
          <Grid item>
            <FormControl sx={{ m: 1 }} style={{ width: "130px" }} size="small">
              <InputLabel id="demo-select-small">Topic</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={selTopicDetails}
                label="Topic"
                onChange={topic_select_onchange}
              >
                <MenuItem value="">None</MenuItem>
                {usertype &&
                usertype != "" &&
                programtype &&
                Array.isArray(topics)
                  ? topics.map((option) => (
                      <MenuItem key={option.topicId} value={option}>
                        {option.topicName}
                      </MenuItem>
                    ))
                  : null}
              </Select>
            </FormControl>
          </Grid>
        </div>
      </div>
      <div className="quiz-open-modal-button">
        <Button
          variant="contained"
          onClick={handleShow}
          disabled={selTopicDetails ? false : true}
        >
          Add Gamified Quiz ➕
        </Button>
      </div>
      {selTopicDetails &&
      selModuleDetails &&
      selSubModuleDetails &&
      programtype &&
      usertype ? (
        <div
          style={{
            backgroundColor: "#f9f9f9",
            border: "1px solid #ccc",
            borderRadius: "5px",
            padding: "20px",
            fontFamily: "Arial, sans-serif",
            color: "#e74c3c", // Red color
            fontSize: "16px",
            lineHeight: "1.5",
            maxWidth: "700px",
            margin: "20px", // Align to left by removing auto margin
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            marginLeft: "32px",
          }}
        >
          <h2
            style={{
              fontSize: "20px",
              marginBottom: "15px",
              color: "#c0392b", // Darker red for the heading
            }}
          >
            Instructional Message
          </h2>
          <p>
            Please ensure that only one matching exercise and one puzzle are
            added. Adding more than one of each may cause issues in the app's
            functionality. Kindly limit the content accordingly.
          </p>
          <h4>
            This message clearly communicates the restriction and the reason
            behind it.
          </h4>
        </div>
      ) : null}

      <div style={{ margin: "7%" }}>
        {selTopicDetails && quizes && quizes.length > 0 ? (
          <>
            {quizes.map((item, index) => (
              <div key={index}>
                <div
                  style={{
                    border: "2px solid blue",
                    padding: "20px",
                    marginTop: "20px",
                    width: "70%",
                  }}
                >
                  <div className="question">
                    <>
                      <b>
                        {index + 1}. {item?.question}
                      </b>
                      {item?.questionMediaType === "image" &&
                      item?.gameQuestionMedia ? (
                        <div style={{ width: "30%", height: "auto" }}>
                          <img
                            src={`https://storage.googleapis.com/tz-bucket-0/${
                              item?.gameQuestionMedia.split("/")[
                                item?.gameQuestionMedia.split("/").length - 1
                              ]
                            }`}
                            alt="quiz_media"
                            style={{ width: "100%", height: "auto" }}
                          />
                        </div>
                      ) : item?.questionMediaType === "audio" &&
                        item?.gameQuestionMedia ? (
                        <div>
                          <audio
                            src={`https://storage.googleapis.com/tz-bucket-0/${
                              item?.gameQuestionMedia.split("/")[
                                item?.gameQuestionMedia.split("/").length - 1
                              ]
                            }`}
                            controls
                          />
                        </div>
                      ) : item?.questionMediaType === "video" &&
                        item?.gameQuestionMedia ? (
                        <div style={{ width: "30%", height: "auto" }}>
                          <video
                            src={`https://storage.googleapis.com/tz-bucket-0/${
                              item?.gameQuestionMedia.split("/")[
                                item?.gameQuestionMedia.split("/").length - 1
                              ]
                            }`}
                            controls
                            style={{ width: "100%", height: "auto" }}
                          />
                        </div>
                      ) : null}
                    </>
                  </div>
                  {item.instructions ? (
                    <div
                      className="instruction"
                      style={{
                        display: "flex",
                        marginLeft: "20px",
                        marginTop: "9px",
                      }}
                    >
                      <b>Instruction-</b>
                      <i>{item.instructions}</i>
                    </div>
                  ) : null}
                  <div
                    className="hints"
                    style={{
                      marginTop: "-3px",
                      marginLeft: "20px",
                      display: "flex",
                    }}
                  >
                    {item.hints ? (
                      <>
                        <b style={{ marginTop: "15px" }}>Hint-</b>
                        <i>
                          <p> {item.hints}</p>
                        </i>
                      </>
                    ) : null}
                  </div>
                  {item.gameType === "selectFromMultiple" &&
                    item.correctAnswer[0].optionA &&
                    item.correctAnswer[0].optionB && (
                      <div style={{ marginTop: "9px" }}>
                        <b>Options-</b>
                      </div>
                    )}

                  <div
                    className="optionsGrid"
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gap: "10px",
                    }}
                  >
                    {["optionA", "optionB", "optionC", "optionD"].map(
                      (option, index) =>
                        item.gameType === "selectFromMultiple" &&
                        item.correctAnswer[0][option] ? (
                          <div
                            className={option}
                            style={{ textAlign: "left" }}
                            key={index}
                          >
                            {item.correctAnswer[0][option].startsWith(
                              "https://"
                            ) ? (
                              item.correctAnswer[0][option].match(
                                /\.(jpeg|jpg|gif|png)$/
                              ) ? (
                                <img
                                  src={item.correctAnswer[0][option]}
                                  alt={`${option} image`}
                                  style={{
                                    width: "60%",
                                    height: "100px",
                                    objectFit: "cover",
                                  }}
                                />
                              ) : item.correctAnswer[0][option].match(
                                  /\.(mp4|webm)$/
                                ) ? (
                                <video
                                  src={item.correctAnswer[0][option]}
                                  controls
                                  style={{
                                    width: "60%",
                                    height: "100px",
                                    objectFit: "cover",
                                  }}
                                />
                              ) : item.correctAnswer[0][option].match(
                                  /\.(mp3|wav)$/
                                ) ? (
                                <audio controls style={{ width: "60%" }}>
                                  <source
                                    src={item.correctAnswer[0][option]}
                                    type="audio/mpeg"
                                  />
                                  Your browser does not support the audio
                                  element.
                                </audio>
                              ) : null
                            ) : (
                              <p>{`${String.fromCharCode(65 + index)}. ${
                                item.correctAnswer[0][option]
                              }`}</p>
                            )}
                          </div>
                        ) : null
                    )}
                  </div>

                  <div>
                    {item.gameType === "rearrangement"
                      ? item.correctAnswer?.map((wordItem, index) => (
                          <div
                            key={index}
                            style={{
                              display: "inline-block",
                              margin: "20px",
                              padding: "5px",
                              border: "1px solid #000", // Outline
                              borderRadius: "5px", // Rounded corners (optional)
                              whiteSpace: "nowrap", // Prevents wrapping
                              minWidth: "80px",
                              height: "33px",
                              backgroundColor: getColorByIndex(index),
                            }}
                          >
                            <p style={{ marginTop: "3%", textAlign: "center" }}>
                              {wordItem.wordValue}
                            </p>
                          </div>
                        ))
                      : null}

                    {item.gameType === "puzzle" ? (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        {item?.correctAnswer?.map((wordItem, index) => (
                          <div
                            key={index}
                            style={{
                              minWidth: "50%", // Adjust width as needed
                              textAlign: "center",
                              margin: "0 0", // Margin between the boxes
                              padding: "20px 10px", // Padding inside the box
                              // border: "0.3px solid #000",
                              backgroundColor: getColorByIndex(index), // Function to get color by index
                              color: "#000",
                              borderRadius: "2px", // Optional rounded corners
                            }}
                          >
                            <p style={{ margin: "0", textAlign: "center" }}>
                              {wordItem?.wordValue}
                            </p>
                          </div>
                        ))}
                      </div>
                    ) : null}
                  </div>

                  <div>
                    {item.gameType === "matching" ? (
                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-around",
                          }}
                        >
                          <p>
                            <b>
                              <u>Left Column</u>
                            </b>
                          </p>
                          <p>
                            <b>
                              <u>Right Column</u>
                            </b>
                          </p>
                        </div>
                        {item.correctAnswer?.map((element, index) => (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-around",
                              textAlign: "center",
                            }}
                          >
                            <p
                              style={{
                                border: "1px solid #000", // Outline
                                borderRadius: "5px", // Rounded corners (optional)
                                whiteSpace: "nowrap", // Prevents wrapping
                                minWidth: "80px",
                                height: "33px",
                                backgroundColor: getColorByIndex(index),
                                paddingTop: "1%",
                              }}
                            >
                              {element.left}
                            </p>
                            <p
                              style={{
                                border: "1px solid #000", // Outline
                                borderRadius: "5px", // Rounded corners (optional)
                                whiteSpace: "nowrap", // Prevents wrapping
                                minWidth: "80px",
                                height: "33px",
                                backgroundColor: getColorByIndex(index),
                                paddingTop: "1%",
                              }}
                            >
                              {element.right}
                            </p>
                          </div>
                        ))}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    {item.gameType === "fillInBlanks" && (
                      <div key={index}>
                        <div
                          style={{
                            border: "1px solid #ddd",
                            padding: "20px",
                            marginTop: "20px",
                            borderRadius: "8px",
                            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                            backgroundColor: "#fff",
                          }}
                        >
                          <div
                            className="fillInBlanks"
                            style={{
                              marginBottom: "15px",
                              padding: "10px",
                              backgroundColor: "#f9f9f9",
                              borderRadius: "5px",
                            }}
                          >
                            <b>Paragraph:</b>
                            {item.fillInBlanksArr.map(
                              (blankItem, blankIndex) => (
                                <p
                                  key={blankIndex}
                                  style={{
                                    fontSize: "16px",
                                    lineHeight: "1.6",
                                    color: "#333",
                                  }}
                                >
                                  {blankItem.text
                                    .split("__________")
                                    .map((segment, i) => (
                                      <span key={i}>
                                        {segment}
                                        {i < blankItem.correctInput.length && (
                                          <input
                                            type="text"
                                            placeholder={`Blank ${blankItem.correctInput[i].blank}`}
                                            style={{
                                              width: "120px",
                                              padding: "5px",
                                              margin: "0 5px",
                                              borderRadius: "5px",
                                              border: "1px solid #ccc",
                                              textAlign: "center",
                                              backgroundColor:
                                                getColorByIndex(i),
                                            }}
                                            value={
                                              blankItem.correctInput[i].answer
                                            }
                                            readOnly
                                          />
                                        )}
                                      </span>
                                    ))}
                                </p>
                              )
                            )}
                          </div>

                          {item.fillInBlanksArr[0].options.length > 0 && (
                            <div
                              className="options"
                              style={{ marginBottom: "15px" }}
                            >
                              <b>Options:</b>
                              <div
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: "10px",
                                  marginTop: "10px",
                                }}
                              >
                                {item.fillInBlanksArr[0].options.map(
                                  (option, optionIndex) => (
                                    <div
                                      key={optionIndex}
                                      style={{
                                        padding: "8px 12px",
                                        // backgroundColor: "#eef",
                                        backgroundColor:
                                          getColorByIndex(optionIndex),
                                        borderRadius: "5px",
                                        textAlign: "center",
                                        boxShadow:
                                          "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                        cursor: "pointer",
                                      }}
                                    >
                                      {option}
                                    </div>
                                  )
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                  <div
                    className="correctOption"
                    style={{ marginTop: "9px", paddingBottom: "20px" }}
                  >
                    {item.gameType === "selectFromMultiple" ? (
                      <b>Answer- {item.correctAnswer[0].correctOption}</b>
                    ) : null}
                    <div>
                      <Button
                        style={{ color: "blue" }}
                        onClick={() => handleShowUpdate(item)}
                      >
                        <ModeEditOutlineIcon />
                      </Button>
                      <Button
                        style={{ color: "red" }}
                        onClick={() => deleteQuestionOnClick(item)}
                      >
                        <DeleteIcon />
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </>
        ) : null}
      </div>

      <Modal
        open={show}
        // onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div>
            {/* --------------------- */}
            <div>
              <Grid container spacing={2}>
                <Grid item xs={5}>
                  <div>
                    {/* Add Question */}
                    <div className="quiz-parent-segment-title ">
                      Add Question
                    </div>
                    <div>
                      <TextField
                        id="add-question"
                        label="Add Question"
                        variant="outlined"
                        multiline
                        rows={3}
                        style={{ width: "500px" }}
                        size="small"
                        value={question}
                        onChange={(e) => setQuestion(e.target.value)}
                      />
                    </div>
                    {/* Add Hints */}
                    <div className="quiz-parent-segment-title ">
                      Add Hints (optional)
                    </div>
                    <div>
                      <TextField
                        id="add-hints"
                        label="Add Hints"
                        variant="outlined"
                        multiline
                        rows={3}
                        style={{ width: "500px" }}
                        size="small"
                        value={hints}
                        onChange={(e) => setHints(e.target.value)}
                      />
                    </div>
                    {/* Add Quiz Media */}
                    {selectedExercise === "matching" ? null : (
                      <>
                        <div className="quiz-parent-segment-title ">
                          Question Media (optional)
                        </div>
                        <div>
                          <div>
                            <FormControl fullWidth size="small">
                              <InputLabel id="quiz-type-select">
                                Select Question Media Type
                              </InputLabel>
                              <Select
                                labelId="quiz-type-label"
                                id="quiz-type-id"
                                value={questionMediaType}
                                label="Select Question Media Type"
                                onChange={quiz_media_type_select_on_change}
                              >
                                <MenuItem value="">None</MenuItem>
                                <MenuItem value="image">Image</MenuItem>
                                <MenuItem value="audio">Audio</MenuItem>
                                <MenuItem value="video">Video</MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                          {!questionMedia?.url && questionMediaType ? (
                            <div>
                              <input
                                type="file"
                                accept={accept}
                                onChange={quiz_media_file_on_change}
                                ref={quizMediaFileRef}
                              />
                            </div>
                          ) : questionMediaType === "image" &&
                            questionMedia?.url ? (
                            <div style={{ marginTop: "10px" }}>
                              <img src={questionMedia.url} alt="quiz_media" />
                            </div>
                          ) : questionMediaType === "audio" &&
                            questionMedia?.url ? (
                            <div style={{ marginTop: "10px" }}>
                              <audio src={questionMedia.url} controls />
                            </div>
                          ) : questionMediaType === "video" &&
                            questionMedia?.url ? (
                            <div style={{ marginTop: "10px" }}>
                              <video
                                src={questionMedia.url}
                                controls
                                width={"80%"}
                              />
                            </div>
                          ) : null}

                          {questionMedia ? (
                            <Button
                              // variant="contained"
                              color="error"
                              onClick={() =>
                                quiz_media_file_on_delete(questionMedia)
                              }
                            >
                              <DeleteIcon />
                            </Button>
                          ) : null}
                        </div>
                      </>
                    )}
                  </div>
                </Grid>
                <Grid item xs={5}>
                  <div>
                    {/* Add Instruction */}
                    <div className="quiz-parent-segment-title ">
                      Add Instructions (optional)
                    </div>
                    <div>
                      <TextField
                        id="add-instructions"
                        label="Add Instructions"
                        variant="outlined"
                        multiline
                        rows={3}
                        style={{ width: "500px" }}
                        size="small"
                        value={instructions}
                        onChange={(e) => setInstructions(e.target.value)}
                      />
                    </div>

                    <div className="quiz-parent-segment-title ">
                      Choose a Game Type
                    </div>

                    <FormControl fullWidth size="small">
                      <InputLabel id="exercise-type-select">
                        Game Type
                      </InputLabel>
                      <Select
                        labelId="exercise-type-label"
                        value={selectedExercise}
                        label="Game Type"
                        onChange={handleChange}
                      >
                        <MenuItem value="selectFromMultiple">
                          Select from Multiple
                        </MenuItem>
                        {/* <MenuItem value="matching">Matching</MenuItem> */}
                        <MenuItem value="rearrangement">
                          Sentence Rearrangements
                        </MenuItem>
                        <MenuItem value="fillInBlanks">
                          Fill in the Blanks
                        </MenuItem>
                        <MenuItem value="puzzle">Puzzles</MenuItem>
                      </Select>
                    </FormControl>

                    {selectedExercise === "selectFromMultiple" ? (
                      <>
                        {/* Select Answer Media */}
                        <div className="quiz-parent-segment-title ">
                          Select Answer Media
                        </div>
                        <div>
                          <FormControl fullWidth size="small">
                            <InputLabel id="quiz-type-select">
                              Select Answer Media
                            </InputLabel>
                            <Select
                              labelId="quiz-types-label"
                              id="quiz-types-id"
                              value={optionMediaType}
                              label="SelectAnswer Media"
                              onChange={handleoptionMediaType}
                            >
                              <MenuItem value="">Select</MenuItem>
                              {answer_media_list.map((qtype) => (
                                <MenuItem key={qtype.value} value={qtype.value}>
                                  {qtype.label}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </div>

                        {/* Select Quiz Type */}
                        <div className="quiz-parent-segment-title ">
                          Select Quiz Type
                        </div>
                        <div>
                          <FormControl fullWidth size="small">
                            <InputLabel id="quiz-type-select">
                              Select Quiz Type
                            </InputLabel>
                            <Select
                              labelId="quiz-type-label"
                              id="quiz-type-id"
                              value={answerType}
                              label="Select Quiz Type"
                              onChange={quiz_type_select_on_change}
                            >
                              <MenuItem value="">Select</MenuItem>
                              {answer_type_list.map((qtype) => (
                                <MenuItem key={qtype.value} value={qtype.value}>
                                  {qtype.label}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </div>
                      </>
                    ) : null}

                    {selectedExercise === "matching" &&
                      matchingQuestions.map((question, index) => (
                        <Grid
                          container
                          spacing={3}
                          style={{ marginTop: "0.5px" }}
                          key={index}
                        >
                          <Grid item xs={5}>
                            {renderQuestionInputs(question, index, "left")}
                          </Grid>
                          <Grid item xs={5}>
                            {renderQuestionInputs(question, index, "right")}
                          </Grid>
                          <Grid item xs={2}>
                            {index === 0 ? (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                {matchingQuestions?.length > 1 && (
                                  <Button
                                    onClick={() => handleRemoveQuestion(index)}
                                    variant="contained"
                                    color="error"
                                    style={{
                                      marginTop: "10px",
                                    }}
                                  >
                                    -
                                  </Button>
                                )}
                                <Button
                                  onClick={handleAddQuestion}
                                  variant="contained"
                                  color="primary"
                                  style={{
                                    marginLeft: "10px",
                                    marginTop: "10px",
                                  }}
                                >
                                  +
                                </Button>
                              </div>
                            ) : (
                              <Button
                                onClick={() => handleRemoveQuestion(index)}
                                variant="contained"
                                color="error"
                                style={{ marginTop: "10px" }}
                              >
                                -
                              </Button>
                            )}
                          </Grid>
                        </Grid>
                      ))}

                    {selectedExercise === "puzzle" &&
                      puzzleQuestions.map((question, index) => (
                        <Grid
                          container
                          spacing={3}
                          style={{ marginTop: "10px" }}
                          key={index}
                        >
                          <Grid item xs={10}>
                            <TextField
                              fullWidth
                              variant="outlined"
                              size="small"
                              value={question.wordValue}
                              onChange={(e) =>
                                handlePuzzleQuestionChange(index, e)
                              }
                            />
                          </Grid>
                          <Grid
                            item
                            xs={2}
                            style={{
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            {index === 0 ? (
                              <>
                                {puzzleQuestions?.length > 1 && (
                                  <Button
                                    onClick={() =>
                                      handleRemovePuzzleQuestion(index)
                                    }
                                    variant="contained"
                                    color="error"
                                  >
                                    -
                                  </Button>
                                )}
                                <Button
                                  onClick={handleAddPuzzleQuestion}
                                  variant="contained"
                                  color="primary"
                                  style={{ marginLeft: "10px" }}
                                >
                                  +
                                </Button>
                              </>
                            ) : (
                              <Button
                                onClick={() =>
                                  handleRemovePuzzleQuestion(index)
                                }
                                variant="contained"
                                color="error"
                              >
                                -
                              </Button>
                            )}
                          </Grid>
                        </Grid>
                      ))}

                    {selectedExercise === "rearrangement" &&
                      sentenceRearrangements.map((sentence, index) => (
                        <Grid
                          container
                          spacing={3}
                          style={{ marginTop: "10px" }}
                          key={index}
                        >
                          <Grid item xs={10}>
                            <TextField
                              fullWidth
                              variant="outlined"
                              size="small"
                              value={sentence.wordValue}
                              onChange={(e) =>
                                handleSentenceRearrangementChange(index, e)
                              }
                            />
                          </Grid>
                          <Grid
                            item
                            xs={2}
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {index === 0 ? (
                              <>
                                {sentenceRearrangements.length > 1 && (
                                  <Button
                                    onClick={() =>
                                      handleRemoveSentenceRearrangement(index)
                                    }
                                    variant="contained"
                                    color="error"
                                  >
                                    -
                                  </Button>
                                )}
                                <Button
                                  onClick={handleAddSentenceRearrangement}
                                  variant="contained"
                                  color="primary"
                                  style={{ marginLeft: "10px" }}
                                >
                                  +
                                </Button>
                              </>
                            ) : (
                              <Button
                                onClick={() =>
                                  handleRemoveSentenceRearrangement(index)
                                }
                                variant="contained"
                                color="error"
                              >
                                -
                              </Button>
                            )}
                          </Grid>
                        </Grid>
                      ))}

                    {selectedExercise === "fillInBlanks" && (
                      <div style={{ marginTop: "10px" }}>
                        <TextField
                          fullWidth
                          variant="outlined"
                          size="small"
                          value={paragraphText}
                          onChange={(e) =>
                            handleParagraphTextChange(e.target.value)
                          }
                          multiline
                          rows={4}
                        />
                        <Button
                          onClick={handleBlankInsert}
                          variant="contained"
                          color="primary"
                          style={{ marginTop: "10px", marginBottom: "10px" }}
                        >
                          Insert Blank
                        </Button>

                        {answers.map((answer, index) => (
                          <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            label={`Answer ${index + 1}`}
                            value={answer?.answer}
                            onChange={(e) =>
                              handleAnswerChange(index, e.target.value)
                            }
                            style={{ marginTop: "10px" }}
                            key={index}
                          />
                        ))}

                        {paragraphOptions.map((option, index) => (
                          <div key={index} style={{ marginTop: "20px" }}>
                            <TextField
                              fullWidth
                              variant="outlined"
                              size="small"
                              label={`Option ${index + 1}`}
                              value={option}
                              onChange={(e) =>
                                handleParagraphOptionChange(
                                  index,
                                  e.target.value
                                )
                              }
                            />
                            <Button
                              onClick={() => handleRemoveParagraphOption(index)}
                              variant="contained"
                              color="error"
                              style={{ marginTop: "10px", marginLeft: "10px" }}
                            >
                              Remove Option
                            </Button>
                          </div>
                        ))}

                        <Button
                          onClick={handleAddParagraphOption}
                          variant="contained"
                          color="primary"
                          style={{ marginTop: "10px" }}
                          disabled={
                            !(
                              paragraphText.includes(" __________ ") || // Check if blank is inserted
                              answers.some(
                                (answer) => answer.answer.trim() !== ""
                              )
                            )
                          }
                        >
                          Add Option
                        </Button>
                      </div>
                    )}
                  </div>
                </Grid>
                <Grid item xs={2}>
                  <div>{/* Preview Quiz Media */}</div>
                </Grid>
              </Grid>
            </div>
            {/* --------------------- */}

            {/* Load Options */}
            {optionMediaType && answerType ? (
              <div>
                {/* 2 Options Area */}

                {showOptions2 && (
                  <div>
                    {/* Options Area */}
                    <div className="quiz-parent-segment-div">
                      <Grid container spacing={2}>
                        <Grid item xs={5}>
                          {/* You can add Quiz Media Preview here */}
                        </Grid>
                        <Grid item xs={5}>
                          <div className="quiz-parent-segment-title">
                            Add Options
                          </div>

                          {/* for quiz type text------------------------------------------- */}
                          {optionMediaType === "text" ? (
                            <Grid container spacing={2}>
                              <Grid item xs={1}>
                                <div className="quiz-parent-segment-title">
                                  A
                                </div>
                              </Grid>
                              <Grid item xs={5}>
                                <div>
                                  <TextField
                                    id="option-a"
                                    label="Option A"
                                    variant="outlined"
                                    size="small"
                                    value={optionA}
                                    onChange={handleOptionAchange}
                                  />
                                </div>
                              </Grid>
                              <Grid item xs={1}>
                                <div className="quiz-parent-segment-title">
                                  B
                                </div>
                              </Grid>
                              <Grid item xs={5}>
                                <div>
                                  <TextField
                                    id="option-b"
                                    label="Option B"
                                    variant="outlined"
                                    size="small"
                                    value={optionB}
                                    onChange={handleOptionBchange}
                                  />
                                </div>
                              </Grid>
                            </Grid>
                          ) : optionMediaType === "image" ? (
                            <Grid container spacing={2}>
                              <Grid item xs={1}>
                                <div className="quiz-parent-segment-title">
                                  A
                                </div>
                              </Grid>
                              <Grid item xs={5}>
                                {!optionA ? (
                                  <input
                                    type="file"
                                    id="optionA"
                                    accept="image/*"
                                    onChange={handleOptionAchange}
                                  />
                                ) : (
                                  <div>
                                    <img src={optionA} alt="optionA Image" />
                                    <Button
                                      style={{ color: "red" }}
                                      onClick={() => optionADelete(optionA)}
                                    >
                                      <DeleteIcon />
                                    </Button>
                                  </div>
                                )}
                              </Grid>
                              <Grid item xs={1}>
                                <div className="quiz-parent-segment-title">
                                  B
                                </div>
                              </Grid>
                              <Grid item xs={5}>
                                {!optionB ? (
                                  <input
                                    type="file"
                                    id="optionB"
                                    accept="image/*"
                                    onChange={handleOptionBchange}
                                  />
                                ) : (
                                  <div>
                                    <img src={optionB} alt="optionB Image" />
                                    <Button
                                      style={{ color: "red" }}
                                      onClick={() => optionBDelete(optionB)}
                                    >
                                      <DeleteIcon />
                                    </Button>
                                  </div>
                                )}
                              </Grid>
                            </Grid>
                          ) : optionMediaType === "audio" ? (
                            <Grid container spacing={2}>
                              <Grid item xs={1}>
                                <div className="quiz-parent-segment-title">
                                  A
                                </div>
                              </Grid>
                              <Grid item xs={5}>
                                {!optionA ? (
                                  <input
                                    type="file"
                                    id="optionA"
                                    accept="audio/*"
                                    onChange={handleOptionAchange}
                                  />
                                ) : (
                                  <div>
                                    <audio controls>
                                      <source src={optionA} type="audio/mpeg" />
                                      browser does not support the audio
                                      element.
                                    </audio>
                                    <Button
                                      style={{ color: "red" }}
                                      onClick={() => optionADelete(optionA)}
                                    >
                                      <DeleteIcon />
                                    </Button>
                                  </div>
                                )}
                              </Grid>
                              <Grid item xs={1}>
                                <div className="quiz-parent-segment-title">
                                  B
                                </div>
                              </Grid>
                              <Grid item xs={5}>
                                {!optionB ? (
                                  <input
                                    type="file"
                                    id="optionB"
                                    accept="audio/*"
                                    onChange={handleOptionBchange}
                                  />
                                ) : (
                                  <div>
                                    <audio controls>
                                      <source src={optionB} type="audio/mpeg" />
                                      browser does not support the audio
                                      element.
                                    </audio>
                                    <Button
                                      style={{ color: "red" }}
                                      onClick={() => optionBDelete(optionB)}
                                    >
                                      <DeleteIcon />
                                    </Button>
                                  </div>
                                )}
                              </Grid>
                            </Grid>
                          ) : null}

                          <br />
                          <div className="quiz-parent-segment-title">
                            Choose Correct Option
                          </div>
                          <div>
                            <FormControl fullWidth size="small">
                              <InputLabel id="quiz-type-select">
                                Select Correct Option
                              </InputLabel>
                              <Select
                                labelId="correct-answers-single-select-label"
                                id="correct-answers-single-select"
                                value={correctOption}
                                onChange={correct_answer_select_on_change}
                                input={
                                  <OutlinedInput
                                    id="select-single"
                                    label="Select Correct Option"
                                  />
                                }
                                renderValue={(selected) => (
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexWrap: "wrap",
                                      gap: 0.5,
                                    }}
                                  >
                                    <Chip key={selected} label={selected} />
                                  </Box>
                                )}
                              >
                                <MenuItem value="optionA">
                                  <Radio
                                    checked={correctOption === "optionA"}
                                  />
                                  <ListItemText primary="optionA" />
                                </MenuItem>
                                <MenuItem value="optionB">
                                  <Radio
                                    checked={correctOption === "optionB"}
                                  />
                                  <ListItemText primary="optionB" />
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                        </Grid>
                      </Grid>
                    </div>
                  </div>
                )}

                {/* 3 Options Area */}
                {showOptions3 && (
                  <div>
                    {/* Options Area */}
                    <div className="quiz-parent-segment-div">
                      <Grid container spacing={2}>
                        <Grid item xs={5}>
                          {/* You can add Quiz Media Preview here */}
                        </Grid>
                        <Grid item xs={5}>
                          <div className="quiz-parent-segment-title">
                            Add Options
                          </div>
                          {optionMediaType === "text" ? (
                            <Grid>
                              <Grid container spacing={2}>
                                <Grid item xs={1}>
                                  <div className="quiz-parent-segment-title">
                                    A
                                  </div>
                                </Grid>
                                <Grid item xs={5}>
                                  <div>
                                    <TextField
                                      id="option-a"
                                      label="Option A"
                                      variant="outlined"
                                      size="small"
                                      value={optionA}
                                      onChange={handleOptionAchange}
                                    />
                                  </div>
                                </Grid>
                                <Grid item xs={1}>
                                  <div className="quiz-parent-segment-title">
                                    B
                                  </div>
                                </Grid>
                                <Grid item xs={5}>
                                  <div>
                                    <TextField
                                      id="option-b"
                                      label="Option B"
                                      variant="outlined"
                                      size="small"
                                      value={optionB}
                                      onChange={handleOptionBchange}
                                    />
                                  </div>
                                </Grid>
                              </Grid>
                              <br />
                              <Grid container spacing={2}>
                                <Grid item xs={1}>
                                  <div className="quiz-parent-segment-title">
                                    C
                                  </div>
                                </Grid>
                                <Grid item xs={5}>
                                  <div>
                                    <TextField
                                      id="option-c"
                                      label="Option C"
                                      variant="outlined"
                                      size="small"
                                      value={optionC}
                                      onChange={handleOptionCchange}
                                    />
                                  </div>
                                </Grid>
                              </Grid>
                            </Grid>
                          ) : optionMediaType === "image" ? (
                            <Grid>
                              <Grid container spacing={2}>
                                <Grid item xs={1}>
                                  <div className="quiz-parent-segment-title">
                                    A
                                  </div>
                                </Grid>
                                <Grid item xs={5}>
                                  {!optionA ? (
                                    <input
                                      type="file"
                                      id="optionA"
                                      accept="image/*"
                                      onChange={handleOptionAchange}
                                    />
                                  ) : (
                                    <div>
                                      <img src={optionA} alt="optionA Image" />
                                      <Button
                                        style={{ color: "red" }}
                                        onClick={() => optionADelete(optionA)}
                                      >
                                        <DeleteIcon />
                                      </Button>
                                    </div>
                                  )}
                                </Grid>
                                <Grid item xs={1}>
                                  <div className="quiz-parent-segment-title">
                                    B
                                  </div>
                                </Grid>
                                <Grid item xs={5}>
                                  {!optionB ? (
                                    <input
                                      type="file"
                                      id="optionB"
                                      accept="image/*"
                                      onChange={handleOptionBchange}
                                    />
                                  ) : (
                                    <div>
                                      <img src={optionB} alt="optionB Image" />
                                      <Button
                                        style={{ color: "red" }}
                                        onClick={() => optionBDelete(optionB)}
                                      >
                                        <DeleteIcon />
                                      </Button>
                                    </div>
                                  )}
                                </Grid>
                              </Grid>
                              <br />
                              <Grid container spacing={2}>
                                <Grid item xs={1}>
                                  <div className="quiz-parent-segment-title">
                                    C
                                  </div>
                                </Grid>
                                <Grid item xs={5}>
                                  {!optionC ? (
                                    <input
                                      type="file"
                                      id="optionC"
                                      accept="image/*"
                                      onChange={handleOptionCchange}
                                    />
                                  ) : (
                                    <div>
                                      <img src={optionC} alt="optionC Image" />
                                      <Button
                                        style={{ color: "red" }}
                                        onClick={() => optionCDelete(optionC)}
                                      >
                                        <DeleteIcon />
                                      </Button>
                                    </div>
                                  )}
                                </Grid>
                              </Grid>
                            </Grid>
                          ) : optionMediaType === "audio" ? (
                            <Grid>
                              <Grid container spacing={2}>
                                <Grid item xs={1}>
                                  <div className="quiz-parent-segment-title">
                                    A
                                  </div>
                                </Grid>
                                <Grid item xs={5}>
                                  {!optionA ? (
                                    <input
                                      type="file"
                                      id="optionA"
                                      accept="audio/*"
                                      onChange={handleOptionAchange}
                                    />
                                  ) : (
                                    <div>
                                      <audio controls>
                                        <source
                                          src={optionA}
                                          type="audio/mpeg"
                                        />
                                        Your browser does not support the audio
                                        element.
                                      </audio>
                                      <Button
                                        style={{ color: "red" }}
                                        onClick={() => optionADelete(optionA)}
                                      >
                                        <DeleteIcon />
                                      </Button>
                                    </div>
                                  )}
                                </Grid>
                                <Grid item xs={1}>
                                  <div className="quiz-parent-segment-title">
                                    B
                                  </div>
                                </Grid>
                                <Grid item xs={5}>
                                  {!optionB ? (
                                    <input
                                      type="file"
                                      id="optionB"
                                      accept="audio/*"
                                      onChange={handleOptionBchange}
                                    />
                                  ) : (
                                    <div>
                                      <audio controls>
                                        <source
                                          src={optionB}
                                          type="audio/mpeg"
                                        />
                                        Your browser does not support the audio
                                        element.
                                      </audio>
                                      <Button
                                        style={{ color: "red" }}
                                        onClick={() => optionBDelete(optionB)}
                                      >
                                        <DeleteIcon />
                                      </Button>
                                    </div>
                                  )}
                                </Grid>
                              </Grid>
                              <br />
                              <Grid container spacing={2}>
                                <Grid item xs={1}>
                                  <div className="quiz-parent-segment-title">
                                    C
                                  </div>
                                </Grid>
                                <Grid item xs={5}>
                                  {!optionC ? (
                                    <input
                                      type="file"
                                      id="optionC"
                                      accept="audio/*"
                                      onChange={handleOptionCchange}
                                    />
                                  ) : (
                                    <div>
                                      <audio controls>
                                        <source
                                          src={optionC}
                                          type="audio/mpeg"
                                        />
                                        Your browser does not support the audio
                                        element.
                                      </audio>
                                      <Button
                                        style={{ color: "red" }}
                                        onClick={() => optionCDelete(optionC)}
                                      >
                                        <DeleteIcon />
                                      </Button>
                                    </div>
                                  )}
                                </Grid>
                              </Grid>
                            </Grid>
                          ) : null}

                          <br />
                          <div className="quiz-parent-segment-title">
                            Choose Correct Option
                          </div>
                          <div>
                            <FormControl fullWidth size="small">
                              <InputLabel id="quiz-type-select">
                                Select Correct Option
                              </InputLabel>
                              <Select
                                labelId="correct-answers-single-select-label"
                                id="correct-answers-single-select"
                                value={correctOption}
                                onChange={correct_answer_select_on_change}
                                input={
                                  <OutlinedInput
                                    id="select-single"
                                    label="Select Correct Option"
                                  />
                                }
                                renderValue={(selected) => (
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexWrap: "wrap",
                                      gap: 0.5,
                                    }}
                                  >
                                    <Chip key={selected} label={selected} />
                                  </Box>
                                )}
                              >
                                <MenuItem value="optionA">
                                  <Radio
                                    checked={correctOption === "optionA"}
                                  />
                                  <ListItemText primary="optionA" />
                                </MenuItem>
                                <MenuItem value="optionB">
                                  <Radio
                                    checked={correctOption === "optionB"}
                                  />
                                  <ListItemText primary="optionB" />
                                </MenuItem>
                                <MenuItem value="optionC">
                                  <Radio
                                    checked={correctOption === "optionC"}
                                  />
                                  <ListItemText primary="optionC" />
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                        </Grid>
                      </Grid>
                    </div>
                  </div>
                )}

                {/* 4 Options Area */}
                {showOptions4 && (
                  <div>
                    {/* Options Area */}
                    <div className="quiz-parent-segment-div">
                      <Grid container spacing={2}>
                        <Grid item xs={5}>
                          {/* You can add Quiz Media Preview here */}
                        </Grid>
                        <Grid item xs={5}>
                          <div className="quiz-parent-segment-title">
                            Add Options
                          </div>
                          {optionMediaType === "text" ? (
                            <Grid>
                              <Grid container spacing={2}>
                                <Grid item xs={1}>
                                  <div className="quiz-parent-segment-title">
                                    A
                                  </div>
                                </Grid>
                                <Grid item xs={5}>
                                  <div>
                                    <TextField
                                      id="option-a"
                                      label="Option A"
                                      variant="outlined"
                                      size="small"
                                      value={optionA}
                                      onChange={handleOptionAchange}
                                    />
                                  </div>
                                </Grid>
                                <Grid item xs={1}>
                                  <div className="quiz-parent-segment-title">
                                    B
                                  </div>
                                </Grid>
                                <Grid item xs={5}>
                                  <div>
                                    <TextField
                                      id="option-b"
                                      label="Option B"
                                      variant="outlined"
                                      size="small"
                                      value={optionB}
                                      onChange={handleOptionBchange}
                                    />
                                  </div>
                                </Grid>
                              </Grid>
                              <br />
                              <Grid container spacing={2}>
                                <Grid item xs={1}>
                                  <div className="quiz-parent-segment-title">
                                    C
                                  </div>
                                </Grid>
                                <Grid item xs={5}>
                                  <div>
                                    <TextField
                                      id="option-c"
                                      label="Option C"
                                      variant="outlined"
                                      size="small"
                                      value={optionC}
                                      onChange={handleOptionCchange}
                                    />
                                  </div>
                                </Grid>
                                <Grid item xs={1}>
                                  <div className="quiz-parent-segment-title">
                                    D
                                  </div>
                                </Grid>
                                <Grid item xs={5}>
                                  <div>
                                    <TextField
                                      id="option-d"
                                      label="Option D"
                                      variant="outlined"
                                      size="small"
                                      value={optionD}
                                      onChange={handleOptionDchange}
                                    />
                                  </div>
                                </Grid>
                              </Grid>
                            </Grid>
                          ) : optionMediaType === "image" ? (
                            <Grid>
                              <Grid container spacing={2}>
                                <Grid item xs={1}>
                                  <div className="quiz-parent-segment-title">
                                    A
                                  </div>
                                </Grid>
                                <Grid item xs={5}>
                                  {!optionA ? (
                                    <input
                                      type="file"
                                      id="optionA"
                                      accept="image/*"
                                      onChange={handleOptionAchange}
                                    />
                                  ) : (
                                    <div>
                                      <img src={optionA} alt="optionA Image" />
                                      <Button
                                        style={{ color: "red" }}
                                        onClick={() => optionADelete(optionA)}
                                      >
                                        <DeleteIcon />
                                      </Button>
                                    </div>
                                  )}
                                </Grid>
                                <Grid item xs={1}>
                                  <div className="quiz-parent-segment-title">
                                    B
                                  </div>
                                </Grid>
                                <Grid item xs={5}>
                                  {!optionB ? (
                                    <input
                                      type="file"
                                      id="optionB"
                                      accept="image/*"
                                      onChange={handleOptionBchange}
                                    />
                                  ) : (
                                    <div>
                                      <img src={optionB} alt="optionB Image" />
                                      <Button
                                        style={{ color: "red" }}
                                        onClick={() => optionBDelete(optionB)}
                                      >
                                        <DeleteIcon />
                                      </Button>
                                    </div>
                                  )}
                                </Grid>
                              </Grid>
                              <br />
                              <Grid container spacing={2}>
                                <Grid item xs={1}>
                                  <div className="quiz-parent-segment-title">
                                    C
                                  </div>
                                </Grid>
                                <Grid item xs={5}>
                                  {!optionC ? (
                                    <input
                                      type="file"
                                      id="optionC"
                                      accept="image/*"
                                      onChange={handleOptionCchange}
                                    />
                                  ) : (
                                    <div>
                                      <img src={optionC} alt="optionC Image" />
                                      <Button
                                        style={{ color: "red" }}
                                        onClick={() => optionCDelete(optionC)}
                                      >
                                        <DeleteIcon />
                                      </Button>
                                    </div>
                                  )}
                                </Grid>
                                <Grid item xs={1}>
                                  <div className="quiz-parent-segment-title">
                                    D
                                  </div>
                                </Grid>
                                <Grid item xs={5}>
                                  {!optionD ? (
                                    <input
                                      type="file"
                                      id="optionD"
                                      accept="image/*"
                                      onChange={handleOptionDchange}
                                    />
                                  ) : (
                                    <div>
                                      <img src={optionD} alt="optionD Image" />
                                      <Button
                                        style={{ color: "red" }}
                                        onClick={() => optionDDelete(optionD)}
                                      >
                                        <DeleteIcon />
                                      </Button>
                                    </div>
                                  )}
                                </Grid>
                              </Grid>
                            </Grid>
                          ) : optionMediaType === "audio" ? (
                            <Grid>
                              <Grid container spacing={2}>
                                <Grid item xs={1}>
                                  <div className="quiz-parent-segment-title">
                                    A
                                  </div>
                                </Grid>
                                <Grid item xs={5}>
                                  {!optionA ? (
                                    <input
                                      type="file"
                                      id="optionA"
                                      accept="audio/*"
                                      onChange={handleOptionAchange}
                                    />
                                  ) : (
                                    <div>
                                      <audio controls>
                                        <source
                                          src={optionA}
                                          type="audio/mpeg"
                                        />
                                        Your browser does not support the audio
                                        element.
                                      </audio>
                                      <Button
                                        style={{ color: "red" }}
                                        onClick={() => optionADelete(optionA)}
                                      >
                                        <DeleteIcon />
                                      </Button>
                                    </div>
                                  )}
                                </Grid>
                                <Grid item xs={1}>
                                  <div className="quiz-parent-segment-title">
                                    B
                                  </div>
                                </Grid>
                                <Grid item xs={5}>
                                  {!optionB ? (
                                    <input
                                      type="file"
                                      id="optionB"
                                      accept="audio/*"
                                      onChange={handleOptionBchange}
                                    />
                                  ) : (
                                    <div>
                                      <audio controls>
                                        <source
                                          src={optionB}
                                          type="audio/mpeg"
                                        />
                                        Your browser does not support the audio
                                        element.
                                      </audio>
                                      <Button
                                        style={{ color: "red" }}
                                        onClick={() => optionBDelete(optionB)}
                                      >
                                        <DeleteIcon />
                                      </Button>
                                    </div>
                                  )}
                                </Grid>
                              </Grid>
                              <br />
                              <Grid container spacing={2}>
                                <Grid item xs={1}>
                                  <div className="quiz-parent-segment-title">
                                    C
                                  </div>
                                </Grid>
                                <Grid item xs={5}>
                                  {!optionC ? (
                                    <input
                                      type="file"
                                      id="optionC"
                                      accept="audio/*"
                                      onChange={handleOptionCchange}
                                    />
                                  ) : (
                                    <div>
                                      <audio controls>
                                        <source
                                          src={optionC}
                                          type="audio/mpeg"
                                        />
                                        Your browser does not support the audio
                                        element.
                                      </audio>
                                      <Button
                                        style={{ color: "red" }}
                                        onClick={() => optionCDelete(optionC)}
                                      >
                                        <DeleteIcon />
                                      </Button>
                                    </div>
                                  )}
                                </Grid>
                                <Grid item xs={1}>
                                  <div className="quiz-parent-segment-title">
                                    D
                                  </div>
                                </Grid>
                                <Grid item xs={5}>
                                  {!optionD ? (
                                    <input
                                      type="file"
                                      id="optionD"
                                      accept="audio/*"
                                      onChange={handleOptionDchange}
                                    />
                                  ) : (
                                    <div>
                                      <audio controls>
                                        <source
                                          src={optionD}
                                          type="audio/mpeg"
                                        />
                                        Your browser does not support the audio
                                        element.
                                      </audio>
                                      <Button
                                        style={{ color: "red" }}
                                        onClick={() => optionDDelete(optionD)}
                                      >
                                        <DeleteIcon />
                                      </Button>
                                    </div>
                                  )}
                                </Grid>
                              </Grid>
                            </Grid>
                          ) : null}

                          <br />
                          <div className="quiz-parent-segment-title">
                            Choose Correct Option
                          </div>
                          <div>
                            <FormControl fullWidth size="small">
                              <InputLabel id="quiz-type-select">
                                Select Correct Option
                              </InputLabel>
                              <Select
                                labelId="correct-answers-single-select-label"
                                id="correct-answers-single-select"
                                value={correctOption}
                                onChange={correct_answer_select_on_change}
                                input={
                                  <OutlinedInput
                                    id="select-single"
                                    label="Select Correct Option"
                                  />
                                }
                                renderValue={(selected) => (
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexWrap: "wrap",
                                      gap: 0.5,
                                    }}
                                  >
                                    <Chip key={selected} label={selected} />
                                  </Box>
                                )}
                              >
                                <MenuItem value="optionA">
                                  <Radio
                                    checked={correctOption === "optionA"}
                                  />
                                  <ListItemText primary="optionA" />
                                </MenuItem>
                                <MenuItem value="optionB">
                                  <Radio
                                    checked={correctOption === "optionB"}
                                  />
                                  <ListItemText primary="optionB" />
                                </MenuItem>
                                <MenuItem value="optionC">
                                  <Radio
                                    checked={correctOption === "optionC"}
                                  />
                                  <ListItemText primary="optionC" />
                                </MenuItem>
                                <MenuItem value="optionD">
                                  <Radio
                                    checked={correctOption === "optionD"}
                                  />
                                  <ListItemText primary="optionD" />
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                        </Grid>
                      </Grid>
                    </div>
                  </div>
                )}

                {/* Yes/No Options Area */}
                {showOptionsYN && (
                  <div>
                    {/* Options Area */}
                    <div className="quiz-parent-segment-div">
                      <Grid container spacing={2}>
                        <Grid item xs={5}>
                          {/* You can add Quiz Media Preview here */}
                        </Grid>
                        <Grid item xs={5}>
                          <div className="quiz-parent-segment-title ">
                            Choose Correct Option(s)
                          </div>
                          <div>
                            <FormControl fullWidth size="small">
                              <InputLabel id="quiz-type-select">
                                Select Correct Option(s)
                              </InputLabel>
                              <Select
                                labelId="coorect-answers-multiselect-chip-label"
                                id="coorect-answers-multiselect-chip"
                                value={correctOption}
                                onChange={correct_answer_select_on_change}
                                input={
                                  <OutlinedInput
                                    id="select-multiple-chip"
                                    label="Select Correct Option(s)"
                                  />
                                }
                                renderValue={(selected) => (
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexWrap: "wrap",
                                      gap: 0.5,
                                    }}
                                  >
                                    {selected?.map((value) => (
                                      <Chip key={value} label={value} />
                                    ))}
                                  </Box>
                                )}
                              >
                                <MenuItem value="yes">
                                  <Checkbox
                                    checked={correctOption.indexOf("yes") > -1}
                                  />
                                  <ListItemText primary="YES" />
                                </MenuItem>
                                <MenuItem value="no">
                                  <Checkbox
                                    checked={correctOption.indexOf("no") > -1}
                                  />
                                  <ListItemText primary="NO" />
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                        </Grid>
                      </Grid>
                    </div>
                  </div>
                )}
              </div>
            ) : null}
          </div>

          <div style={{ marginBottom: "100px" }}>
            <Button
              variant="outlined"
              style={{ marginLeft: 12 }}
              onClick={close_quiz_dialog}
            >
              Close
            </Button>
            {loadingSave ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "right",
                }}
              >
                <CircularProgress />
              </div>
            ) : (
              <Button variant="contained" onClick={handleSave}>
                Save
              </Button>
            )}
          </div>
        </Box>
      </Modal>

      {/**----------------Update Modal--------------- */}
      <Modal
        open={showUpdate}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div>
            <div>
              <Grid container spacing={2}>
                <Grid item xs={5}>
                  <div>
                    <div className="quiz-parent-segment-title ">
                      Add Question
                    </div>
                    <div>
                      <TextField
                        id="add-question"
                        label="Add Question"
                        variant="outlined"
                        multiline
                        rows={3}
                        style={{ width: "470px" }}
                        size="small"
                        value={updateData?.question}
                        onChange={(e) =>
                          setUpdateData({
                            ...updateData,
                            question: e.target.value,
                          })
                        }
                      />
                    </div>
                    {/* Add Hints */}
                    <div className="quiz-parent-segment-title ">
                      Add Hints (optional)
                    </div>
                    <div>
                      <TextField
                        id="add-hints"
                        label="Add Hints"
                        variant="outlined"
                        multiline
                        rows={3}
                        style={{ width: "470px" }}
                        size="small"
                        value={updateData?.hints}
                        onChange={(e) =>
                          setUpdateData({
                            ...updateData,
                            hints: e.target.value,
                          })
                        }
                      />
                    </div>
                    {/* Add Quiz Media */}
                    {updateData.gameType === "matching" ? null : (
                      <>
                        <div className="quiz-parent-segment-title ">
                          Question Media (optional)
                        </div>
                        <div>
                          <div>
                            <FormControl fullWidth size="small">
                              <InputLabel id="quiz-type-select">
                                Select Question Media Type
                              </InputLabel>
                              <Select
                                labelId="quiz-type-label"
                                id="quiz-type-id"
                                value={updateData?.questionMediaType}
                                label="Select Question Media Type"
                                onChange={(e) =>
                                  setUpdateData({
                                    ...updateData,
                                    questionMediaType: e.target.value,
                                  })
                                }
                              >
                                <MenuItem value="">None</MenuItem>
                                <MenuItem value="image">Image</MenuItem>
                                <MenuItem value="audio">Audio</MenuItem>
                                <MenuItem value="video">Video</MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                          {!updateData?.gameQuestionMedia &&
                          updateData?.questionMediaType ? (
                            <div>
                              <input
                                type="file"
                                accept={`${updateData?.questionMediaType}/*`}
                                onChange={quiz_media_file_on_change}
                                ref={quizMediaFileRef}
                              />
                            </div>
                          ) : updateData?.questionMediaType === "image" &&
                            updateData?.gameQuestionMedia ? (
                            <div>
                              <img
                                src={updateData?.gameQuestionMedia}
                                alt="quiz_media"
                              />
                            </div>
                          ) : updateData?.questionMediaType === "audio" &&
                            updateData?.gameQuestionMedia ? (
                            <div>
                              <audio
                                src={updateData?.gameQuestionMedia}
                                controls
                              />
                            </div>
                          ) : updateData?.questionMediaType === "video" &&
                            updateData?.gameQuestionMedia ? (
                            <div>
                              <video
                                src={updateData?.gameQuestionMedia}
                                controls
                              />
                            </div>
                          ) : null}

                          {updateData?.gameQuestionMedia ? (
                            <Button
                              // variant="contained"
                              color="error"
                              onClick={() =>
                                quiz_media_file_on_delete(
                                  updateData?.gameQuestionMedia
                                )
                              }
                            >
                              <DeleteIcon />
                            </Button>
                          ) : null}
                        </div>
                      </>
                    )}
                  </div>
                </Grid>
                <Grid item xs={5}>
                  <div>
                    {/* Add Instruction */}
                    <div className="quiz-parent-segment-title ">
                      Add Instructions (optional)
                    </div>
                    <div>
                      <TextField
                        id="add-instructions"
                        label="Add Instructions"
                        variant="outlined"
                        multiline
                        rows={3}
                        style={{ width: "470px" }}
                        size="small"
                        value={updateData?.instructions}
                        onChange={(e) =>
                          setUpdateData({
                            ...updateData,
                            instructions: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="quiz-parent-segment-title ">
                      Choose a Game Type
                    </div>
                    <FormControl fullWidth size="small">
                      <InputLabel id="exercise-type-select">
                        Game Type
                      </InputLabel>
                      <Select
                        labelId="exercise-type-label"
                        value={updateData?.gameType}
                        label="Game Type"
                        onChange={handleUpdateChange}
                        disabled={true}
                      >
                        <MenuItem value="selectFromMultiple">
                          Select from Multiple
                        </MenuItem>
                        <MenuItem value="matching">Matching</MenuItem>
                        <MenuItem value="rearrangement">
                          Sentence Rearrangements
                        </MenuItem>
                        <MenuItem value="fillInBlanks">
                          Fill in the Blanks
                        </MenuItem>
                        <MenuItem value="puzzle">Puzzles</MenuItem>
                      </Select>
                    </FormControl>
                    {updateData?.gameType === "selectFromMultiple" ? (
                      <>
                        <div className="quiz-parent-segment-title ">
                          Select Answer Media
                        </div>
                        <div>
                          <FormControl fullWidth size="small">
                            <InputLabel id="quiz-type-select">
                              Select Answer Media
                            </InputLabel>
                            <Select
                              labelId="quiz-types-label"
                              id="quiz-types-id"
                              value={
                                updateData.correctAnswer[0].optionMediaType
                              }
                              label="SelectAnswer Media"
                              onChange={(e) =>
                                setUpdateData({
                                  ...updateData,
                                  optionMediaType: e.target.value,
                                  correctOption: "",
                                  optionA: "",
                                  optionB: "",
                                  optionC: "",
                                  optionD: "",
                                })
                              }
                            >
                              <MenuItem value="">Select</MenuItem>
                              {answer_media_list.map((qtype) => (
                                <MenuItem key={qtype.value} value={qtype.value}>
                                  {qtype.label}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </div>
                        <div className="quiz-parent-segment-title ">
                          Select Quiz Type
                        </div>
                        <div>
                          <FormControl fullWidth size="small">
                            <InputLabel id="quiz-type-select">
                              Select Quiz Type
                            </InputLabel>
                            <Select
                              labelId="quiz-type-label"
                              id="quiz-type-id"
                              value={updateData.correctAnswer[0].answerType}
                              label="Select Quiz Type"
                              onChange={(e) =>
                                setUpdateData({
                                  ...updateData,
                                  answerType: e.target.value,
                                  correctOption: "",
                                  optionA: "",
                                  optionB: "",
                                  optionC: "",
                                  optionD: "",
                                })
                              }
                            >
                              <MenuItem value="">Select</MenuItem>
                              {answer_type_list.map((qtype) => (
                                <MenuItem key={qtype.value} value={qtype.value}>
                                  {qtype.label}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </div>
                        {/* Load Options */}
                        {updateData.correctAnswer[0].optionMediaType &&
                        updateData.correctAnswer[0].answerType ? (
                          <div>
                            {/* 2 Options Area */}

                            {updateData.correctAnswer[0].answerType ===
                              "2options" && (
                              <div>
                                {/* Options Area */}
                                <div className="quiz-parent-segment-div">
                                  <Grid container spacing={2}>
                                    <Grid item xs={15}>
                                      {/* You can add Quiz Media Preview here */}
                                    </Grid>
                                    <Grid item xs={15}>
                                      <div className="quiz-parent-segment-title">
                                        Add Options
                                      </div>

                                      {/* for quiz type text------------------------------------------- */}
                                      {updateData.correctAnswer[0]
                                        .optionMediaType === "text" ? (
                                        <Grid container spacing={2}>
                                          <Grid item xs={1}>
                                            <div className="quiz-parent-segment-title">
                                              A
                                            </div>
                                          </Grid>
                                          <Grid item xs={5}>
                                            <div>
                                              <TextField
                                                id="option-a"
                                                label="Option A"
                                                variant="outlined"
                                                size="small"
                                                value={
                                                  updateData.correctAnswer[0]
                                                    ?.optionA || ""
                                                }
                                                onChange={(e) => {
                                                  const updatedCorrectAnswer = [
                                                    ...updateData.correctAnswer,
                                                  ];
                                                  updatedCorrectAnswer[0] = {
                                                    ...updatedCorrectAnswer[0],
                                                    optionA: e.target.value,
                                                  };

                                                  setUpdateData({
                                                    ...updateData,
                                                    correctAnswer:
                                                      updatedCorrectAnswer,
                                                  });
                                                }}
                                              />
                                            </div>
                                          </Grid>
                                          <Grid item xs={1}>
                                            <div className="quiz-parent-segment-title">
                                              B
                                            </div>
                                          </Grid>
                                          <Grid item xs={5}>
                                            <div>
                                              <TextField
                                                id="option-a"
                                                label="Option A"
                                                variant="outlined"
                                                size="small"
                                                value={
                                                  updateData.correctAnswer[0]
                                                    ?.optionB || ""
                                                }
                                                onChange={(e) => {
                                                  const updatedCorrectAnswer = [
                                                    ...updateData.correctAnswer,
                                                  ];
                                                  updatedCorrectAnswer[0] = {
                                                    ...updatedCorrectAnswer[0],
                                                    optionB: e.target.value,
                                                  };

                                                  setUpdateData({
                                                    ...updateData,
                                                    correctAnswer:
                                                      updatedCorrectAnswer,
                                                  });
                                                }}
                                              />
                                            </div>
                                          </Grid>
                                        </Grid>
                                      ) : (
                                        <Grid container spacing={2}>
                                          <Grid item xs={1}>
                                            <div className="quiz-parent-segment-title">
                                              A
                                            </div>
                                          </Grid>
                                          <Grid item xs={5}>
                                            {updateData.correctAnswer[0]
                                              .optionMediaType === "image" &&
                                            !updateData.correctAnswer[0]
                                              .optionA ? (
                                              <input
                                                type="file"
                                                id="optionA"
                                                accept={"image/*"}
                                                onChange={handleOptionAchange}
                                                // ref={quizMediaFileRef}
                                              />
                                            ) : (
                                              <div>
                                                {" "}
                                                <img
                                                  src={
                                                    updateData.correctAnswer[0]
                                                      .optionA
                                                  }
                                                  alt="optionA Image"
                                                />
                                                <Button
                                                  style={{ color: "red" }}
                                                  onClick={() =>
                                                    optionADelete(
                                                      updateData
                                                        .correctAnswer[0]
                                                        .optionA
                                                    )
                                                  }
                                                >
                                                  <DeleteIcon />
                                                </Button>
                                              </div>
                                            )}
                                          </Grid>
                                          <Grid item xs={1}>
                                            <div className="quiz-parent-segment-title">
                                              B
                                            </div>
                                          </Grid>
                                          <Grid item xs={5}>
                                            {updateData.correctAnswer[0]
                                              .optionMediaType === "image" &&
                                            !updateData.correctAnswer[0]
                                              .optionB ? (
                                              <input
                                                type="file"
                                                id="optionB"
                                                accept={"image/*"}
                                                onChange={handleOptionBchange}
                                              />
                                            ) : (
                                              <div>
                                                {" "}
                                                <img
                                                  src={
                                                    updateData.correctAnswer[0]
                                                      .optionB
                                                  }
                                                  alt="optionB Image"
                                                />
                                                <Button
                                                  style={{ color: "red" }}
                                                  onClick={() =>
                                                    optionBDelete(
                                                      updateData
                                                        .correctAnswer[0]
                                                        .optionB
                                                    )
                                                  }
                                                >
                                                  <DeleteIcon />
                                                </Button>
                                              </div>
                                            )}
                                          </Grid>
                                        </Grid>
                                      )}
                                      <br />
                                      <div className="quiz-parent-segment-title">
                                        Choose Correct Option
                                      </div>
                                      <div>
                                        <FormControl fullWidth size="small">
                                          <InputLabel id="quiz-type-select">
                                            Select Correct Option
                                          </InputLabel>
                                          <Select
                                            labelId="correct-answers-single-select-label"
                                            id="correct-answers-single-select"
                                            value={
                                              updateData.correctAnswer[0]
                                                ?.correctOption || ""
                                            }
                                            onChange={(e) => {
                                              const updatedCorrectAnswer = [
                                                ...updateData.correctAnswer,
                                              ];
                                              updatedCorrectAnswer[0] = {
                                                ...updatedCorrectAnswer[0],
                                                correctOption: e.target.value, // Update correctOption within correctAnswer[0]
                                              };

                                              setUpdateData({
                                                ...updateData,
                                                correctAnswer:
                                                  updatedCorrectAnswer,
                                              });
                                            }}
                                            input={
                                              <OutlinedInput
                                                id="select-single"
                                                label="Select Correct Option"
                                              />
                                            }
                                            renderValue={(selected) => (
                                              <Box
                                                sx={{
                                                  display: "flex",
                                                  flexWrap: "wrap",
                                                  gap: 0.5,
                                                }}
                                              >
                                                <Chip
                                                  key={selected}
                                                  label={selected}
                                                />
                                              </Box>
                                            )}
                                          >
                                            <MenuItem value="optionA">
                                              <Radio
                                                checked={
                                                  updateData.correctAnswer[0]
                                                    ?.correctOption ===
                                                  "optionA"
                                                }
                                              />
                                              <ListItemText primary="optionA" />
                                            </MenuItem>
                                            <MenuItem value="optionB">
                                              <Radio
                                                checked={
                                                  updateData.correctAnswer[0]
                                                    ?.correctOption ===
                                                  "optionB"
                                                }
                                              />
                                              <ListItemText primary="optionB" />
                                            </MenuItem>
                                          </Select>
                                        </FormControl>
                                      </div>
                                    </Grid>
                                  </Grid>
                                </div>
                              </div>
                            )}

                            {/* 3 Options Area */}
                            {updateData.correctAnswer[0].answerType ===
                              "3options" && (
                              <div>
                                {/* Options Area */}
                                <div className="quiz-parent-segment-div">
                                  <Grid container spacing={2}>
                                    <Grid item xs={15}>
                                      {/* You can add Quiz Media Preview here */}
                                    </Grid>
                                    <Grid item xs={15}>
                                      <div className="quiz-parent-segment-title">
                                        Add Options
                                      </div>
                                      {updateData.correctAnswer[0]
                                        .optionMediaType === "text" ? (
                                        <Grid>
                                          <Grid container spacing={2}>
                                            <Grid item xs={1}>
                                              <div className="quiz-parent-segment-title">
                                                A
                                              </div>
                                            </Grid>
                                            <Grid item xs={5}>
                                              <div>
                                                <TextField
                                                  id="option-a"
                                                  label="Option A"
                                                  variant="outlined"
                                                  size="small"
                                                  value={
                                                    updateData.correctAnswer[0]
                                                      ?.optionA || ""
                                                  }
                                                  onChange={(e) => {
                                                    const updatedCorrectAnswer =
                                                      [
                                                        ...updateData.correctAnswer,
                                                      ];
                                                    updatedCorrectAnswer[0] = {
                                                      ...updatedCorrectAnswer[0],
                                                      optionA: e.target.value,
                                                    };

                                                    setUpdateData({
                                                      ...updateData,
                                                      correctAnswer:
                                                        updatedCorrectAnswer,
                                                    });
                                                  }}
                                                />
                                              </div>
                                            </Grid>
                                            <Grid item xs={1}>
                                              <div className="quiz-parent-segment-title">
                                                B
                                              </div>
                                            </Grid>
                                            <Grid item xs={5}>
                                              <div>
                                                <TextField
                                                  id="option-a"
                                                  label="Option A"
                                                  variant="outlined"
                                                  size="small"
                                                  value={
                                                    updateData.correctAnswer[0]
                                                      ?.optionB || ""
                                                  }
                                                  onChange={(e) => {
                                                    const updatedCorrectAnswer =
                                                      [
                                                        ...updateData.correctAnswer,
                                                      ];
                                                    updatedCorrectAnswer[0] = {
                                                      ...updatedCorrectAnswer[0],
                                                      optionB: e.target.value,
                                                    };

                                                    setUpdateData({
                                                      ...updateData,
                                                      correctAnswer:
                                                        updatedCorrectAnswer,
                                                    });
                                                  }}
                                                />
                                              </div>
                                            </Grid>
                                          </Grid>
                                          <br />
                                          <Grid container spacing={2}>
                                            <Grid item xs={1}>
                                              <div className="quiz-parent-segment-title">
                                                C
                                              </div>
                                            </Grid>
                                            <Grid item xs={5}>
                                              <div>
                                                <TextField
                                                  id="option-a"
                                                  label="Option A"
                                                  variant="outlined"
                                                  size="small"
                                                  value={
                                                    updateData.correctAnswer[0]
                                                      ?.optionC || ""
                                                  }
                                                  onChange={(e) => {
                                                    const updatedCorrectAnswer =
                                                      [
                                                        ...updateData.correctAnswer,
                                                      ];
                                                    updatedCorrectAnswer[0] = {
                                                      ...updatedCorrectAnswer[0],
                                                      optionC: e.target.value,
                                                    };

                                                    setUpdateData({
                                                      ...updateData,
                                                      correctAnswer:
                                                        updatedCorrectAnswer,
                                                    });
                                                  }}
                                                />
                                              </div>
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      ) : (
                                        <Grid>
                                          <Grid container spacing={2}>
                                            <Grid item xs={1}>
                                              <div className="quiz-parent-segment-title">
                                                A
                                              </div>
                                            </Grid>
                                            <Grid item xs={5}>
                                              {updateData.correctAnswer[0]
                                                .optionMediaType === "image" &&
                                              !updateData.correctAnswer[0]
                                                .optionA ? (
                                                <input
                                                  type="file"
                                                  id="optionA"
                                                  accept={"image/*"}
                                                  onChange={handleOptionAchange}
                                                  // ref={quizMediaFileRef}
                                                />
                                              ) : (
                                                <div>
                                                  {" "}
                                                  <img
                                                    src={
                                                      updateData
                                                        .correctAnswer[0]
                                                        .optionA
                                                    }
                                                    alt="optionA Image"
                                                  />
                                                  <Button
                                                    style={{ color: "red" }}
                                                    onClick={() =>
                                                      optionADelete(
                                                        updateData
                                                          .correctAnswer[0]
                                                          .optionA
                                                      )
                                                    }
                                                  >
                                                    <DeleteIcon />
                                                  </Button>
                                                </div>
                                              )}
                                            </Grid>
                                            <Grid item xs={1}>
                                              <div className="quiz-parent-segment-title">
                                                B
                                              </div>
                                            </Grid>
                                            <Grid item xs={5}>
                                              {updateData.correctAnswer[0]
                                                .optionMediaType === "image" &&
                                              !updateData.correctAnswer[0]
                                                .optionB ? (
                                                <input
                                                  type="file"
                                                  id="optionB"
                                                  accept={"image/*"}
                                                  onChange={handleOptionBchange}
                                                  // ref={quizMediaFileRef}
                                                />
                                              ) : (
                                                <div>
                                                  <img
                                                    src={
                                                      updateData
                                                        .correctAnswer[0]
                                                        .optionB
                                                    }
                                                    alt="optionB Image"
                                                  />
                                                  <Button
                                                    style={{ color: "red" }}
                                                    onClick={() =>
                                                      optionBDelete(
                                                        updateData
                                                          .correctAnswer[0]
                                                          .optionB
                                                      )
                                                    }
                                                  >
                                                    <DeleteIcon />
                                                  </Button>
                                                </div>
                                              )}
                                            </Grid>
                                          </Grid>
                                          <br />
                                          <Grid container spacing={2}>
                                            <Grid item xs={1}>
                                              <div className="quiz-parent-segment-title">
                                                C
                                              </div>
                                            </Grid>
                                            <Grid item xs={5}>
                                              {updateData.correctAnswer[0]
                                                .optionMediaType === "image" &&
                                              !updateData.correctAnswer[0]
                                                .optionC ? (
                                                <input
                                                  type="file"
                                                  id="optionC"
                                                  accept={"image/*"}
                                                  onChange={handleOptionCchange}
                                                />
                                              ) : (
                                                <div>
                                                  <img
                                                    src={
                                                      updateData
                                                        .correctAnswer[0]
                                                        .optionC
                                                    }
                                                    alt="optionC Image"
                                                  />
                                                  <Button
                                                    style={{ color: "red" }}
                                                    onClick={() =>
                                                      optionCDelete(
                                                        updateData
                                                          .correctAnswer[0]
                                                          .optionC
                                                      )
                                                    }
                                                  >
                                                    <DeleteIcon />
                                                  </Button>
                                                </div>
                                              )}
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      )}
                                      <br />
                                      <div className="quiz-parent-segment-title">
                                        Choose Correct Option
                                      </div>
                                      <div>
                                        <FormControl fullWidth size="small">
                                          <InputLabel id="quiz-type-select">
                                            Select Correct Option
                                          </InputLabel>
                                          <Select
                                            labelId="correct-answers-single-select-label"
                                            id="correct-answers-single-select"
                                            value={
                                              updateData.correctAnswer[0]
                                                ?.correctOption || ""
                                            }
                                            onChange={(e) => {
                                              const updatedCorrectAnswer = [
                                                ...updateData.correctAnswer,
                                              ];
                                              updatedCorrectAnswer[0] = {
                                                ...updatedCorrectAnswer[0],
                                                correctOption: e.target.value, // Update correctOption within correctAnswer[0]
                                              };

                                              setUpdateData({
                                                ...updateData,
                                                correctAnswer:
                                                  updatedCorrectAnswer,
                                              });
                                            }}
                                            input={
                                              <OutlinedInput
                                                id="select-single"
                                                label="Select Correct Option"
                                              />
                                            }
                                            renderValue={(selected) => (
                                              <Box
                                                sx={{
                                                  display: "flex",
                                                  flexWrap: "wrap",
                                                  gap: 0.5,
                                                }}
                                              >
                                                <Chip
                                                  key={selected}
                                                  label={selected}
                                                />
                                              </Box>
                                            )}
                                          >
                                            <MenuItem value="optionA">
                                              <Radio
                                                checked={
                                                  updateData.correctAnswer[0]
                                                    ?.correctOption ===
                                                  "optionA"
                                                }
                                              />
                                              <ListItemText primary="optionA" />
                                            </MenuItem>
                                            <MenuItem value="optionB">
                                              <Radio
                                                checked={
                                                  updateData.correctAnswer[0]
                                                    ?.correctOption ===
                                                  "optionB"
                                                }
                                              />
                                              <ListItemText primary="optionB" />
                                            </MenuItem>
                                            <MenuItem value="optionC">
                                              <Radio
                                                checked={
                                                  updateData.correctAnswer[0]
                                                    ?.correctOption ===
                                                  "optionC"
                                                }
                                              />
                                              <ListItemText primary="optionC" />
                                            </MenuItem>
                                          </Select>
                                        </FormControl>
                                      </div>
                                    </Grid>
                                  </Grid>
                                </div>
                              </div>
                            )}

                            {/* 4 Options Area */}
                            {updateData.correctAnswer[0].answerType ===
                              "4options" && (
                              <div>
                                {/* Options Area */}
                                <div className="quiz-parent-segment-div">
                                  <Grid container spacing={2}>
                                    <Grid item xs={15}>
                                      {/* You can add Quiz Media Preview here */}
                                    </Grid>
                                    <Grid item xs={15}>
                                      <div className="quiz-parent-segment-title">
                                        Add Options
                                      </div>
                                      {updateData.correctAnswer[0]
                                        .optionMediaType === "text" ? (
                                        <Grid>
                                          <Grid container spacing={2}>
                                            <Grid item xs={1}>
                                              <div className="quiz-parent-segment-title">
                                                A
                                              </div>
                                            </Grid>
                                            <Grid item xs={5}>
                                              <div>
                                                <TextField
                                                  id="option-a"
                                                  label="Option A"
                                                  variant="outlined"
                                                  size="small"
                                                  value={
                                                    updateData.correctAnswer[0]
                                                      ?.optionA || ""
                                                  }
                                                  onChange={(e) => {
                                                    const updatedCorrectAnswer =
                                                      [
                                                        ...updateData.correctAnswer,
                                                      ];
                                                    updatedCorrectAnswer[0] = {
                                                      ...updatedCorrectAnswer[0],
                                                      optionA: e.target.value,
                                                    };
                                                    setUpdateData({
                                                      ...updateData,
                                                      correctAnswer:
                                                        updatedCorrectAnswer,
                                                    });
                                                  }}
                                                />
                                              </div>
                                            </Grid>
                                            <Grid item xs={1}>
                                              <div className="quiz-parent-segment-title">
                                                B
                                              </div>
                                            </Grid>
                                            <Grid item xs={5}>
                                              <div>
                                                <TextField
                                                  id="option-a"
                                                  label="Option A"
                                                  variant="outlined"
                                                  size="small"
                                                  value={
                                                    updateData.correctAnswer[0]
                                                      ?.optionB || ""
                                                  }
                                                  onChange={(e) => {
                                                    const updatedCorrectAnswer =
                                                      [
                                                        ...updateData.correctAnswer,
                                                      ];
                                                    updatedCorrectAnswer[0] = {
                                                      ...updatedCorrectAnswer[0],
                                                      optionB: e.target.value,
                                                    };
                                                    setUpdateData({
                                                      ...updateData,
                                                      correctAnswer:
                                                        updatedCorrectAnswer,
                                                    });
                                                  }}
                                                />
                                              </div>
                                            </Grid>
                                          </Grid>
                                          <br />
                                          <Grid container spacing={2}>
                                            <Grid item xs={1}>
                                              <div className="quiz-parent-segment-title">
                                                C
                                              </div>
                                            </Grid>
                                            <Grid item xs={5}>
                                              <div>
                                                <TextField
                                                  id="option-a"
                                                  label="Option A"
                                                  variant="outlined"
                                                  size="small"
                                                  value={
                                                    updateData.correctAnswer[0]
                                                      ?.optionC || ""
                                                  }
                                                  onChange={(e) => {
                                                    const updatedCorrectAnswer =
                                                      [
                                                        ...updateData.correctAnswer,
                                                      ];
                                                    updatedCorrectAnswer[0] = {
                                                      ...updatedCorrectAnswer[0],
                                                      optionC: e.target.value,
                                                    };

                                                    setUpdateData({
                                                      ...updateData,
                                                      correctAnswer:
                                                        updatedCorrectAnswer,
                                                    });
                                                  }}
                                                />
                                              </div>
                                            </Grid>
                                            <Grid item xs={1}>
                                              <div className="quiz-parent-segment-title">
                                                D
                                              </div>
                                            </Grid>
                                            <Grid item xs={5}>
                                              <div>
                                                <TextField
                                                  id="option-a"
                                                  label="Option A"
                                                  variant="outlined"
                                                  size="small"
                                                  value={
                                                    updateData.correctAnswer[0]
                                                      ?.optionD || ""
                                                  }
                                                  onChange={(e) => {
                                                    const updatedCorrectAnswer =
                                                      [
                                                        ...updateData.correctAnswer,
                                                      ];
                                                    updatedCorrectAnswer[0] = {
                                                      ...updatedCorrectAnswer[0],
                                                      optionD: e.target.value,
                                                    };

                                                    setUpdateData({
                                                      ...updateData,
                                                      correctAnswer:
                                                        updatedCorrectAnswer,
                                                    });
                                                  }}
                                                />
                                              </div>
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      ) : (
                                        <Grid>
                                          <Grid container spacing={2}>
                                            <Grid item xs={1}>
                                              <div className="quiz-parent-segment-title">
                                                A
                                              </div>
                                            </Grid>
                                            <Grid item xs={5}>
                                              {updateData.correctAnswer[0]
                                                .optionMediaType === "image" &&
                                              !updateData.correctAnswer[0]
                                                .optionA ? (
                                                <input
                                                  type="file"
                                                  id="optionA"
                                                  accept={"image/*"}
                                                  onChange={handleOptionAchange}
                                                />
                                              ) : (
                                                <div>
                                                  <img
                                                    src={
                                                      updateData
                                                        .correctAnswer[0]
                                                        .optionA
                                                    }
                                                    alt="optionA Image"
                                                  />
                                                  <Button
                                                    style={{ color: "red" }}
                                                    onClick={() =>
                                                      optionADelete(
                                                        updateData
                                                          .correctAnswer[0]
                                                          .optionA
                                                      )
                                                    }
                                                  >
                                                    <DeleteIcon />
                                                  </Button>
                                                </div>
                                              )}
                                            </Grid>
                                            <Grid item xs={1}>
                                              <div className="quiz-parent-segment-title">
                                                B
                                              </div>
                                            </Grid>
                                            <Grid item xs={5}>
                                              {updateData.correctAnswer[0]
                                                .optionMediaType === "image" &&
                                              !updateData.correctAnswer[0]
                                                .optionB ? (
                                                <input
                                                  type="file"
                                                  id="optionB"
                                                  accept={"image/*"}
                                                  onChange={handleOptionBchange}
                                                />
                                              ) : (
                                                <div>
                                                  {" "}
                                                  <img
                                                    src={
                                                      updateData
                                                        .correctAnswer[0]
                                                        .optionB
                                                    }
                                                    alt="optionB Image"
                                                  />
                                                  <Button
                                                    style={{ color: "red" }}
                                                    onClick={() =>
                                                      optionBDelete(
                                                        updateData
                                                          .correctAnswer[0]
                                                          .optionB
                                                      )
                                                    }
                                                  >
                                                    <DeleteIcon />
                                                  </Button>
                                                </div>
                                              )}
                                            </Grid>
                                          </Grid>
                                          <br />
                                          <Grid container spacing={2}>
                                            <Grid item xs={1}>
                                              <div className="quiz-parent-segment-title">
                                                C
                                              </div>
                                            </Grid>
                                            <Grid item xs={5}>
                                              {updateData.correctAnswer[0]
                                                .optionMediaType === "image" &&
                                              !updateData.correctAnswer[0]
                                                .optionC ? (
                                                <input
                                                  type="file"
                                                  id="optionC"
                                                  accept={"image/*"}
                                                  onChange={handleOptionCchange}
                                                />
                                              ) : (
                                                <div>
                                                  {" "}
                                                  <img
                                                    src={
                                                      updateData
                                                        .correctAnswer[0]
                                                        .optionC
                                                    }
                                                    alt="optionC Image"
                                                  />
                                                  <Button
                                                    style={{ color: "red" }}
                                                    onClick={() =>
                                                      optionCDelete(
                                                        updateData
                                                          .correctAnswer[0]
                                                          .optionC
                                                      )
                                                    }
                                                  >
                                                    <DeleteIcon />
                                                  </Button>
                                                </div>
                                              )}
                                            </Grid>
                                            <Grid item xs={1}>
                                              <div className="quiz-parent-segment-title">
                                                D
                                              </div>
                                            </Grid>
                                            <Grid item xs={5}>
                                              {updateData.correctAnswer[0]
                                                .optionMediaType === "image" &&
                                              !updateData.correctAnswer[0]
                                                .optionD ? (
                                                <input
                                                  type="file"
                                                  id="optionD"
                                                  accept={"image/*"}
                                                  onChange={handleOptionDchange}
                                                />
                                              ) : (
                                                <div>
                                                  {" "}
                                                  <img
                                                    src={
                                                      updateData
                                                        .correctAnswer[0]
                                                        .optionD
                                                    }
                                                    alt="optionD Image"
                                                  />
                                                  <Button
                                                    style={{ color: "red" }}
                                                    onClick={() =>
                                                      optionDDelete(
                                                        updateData
                                                          .correctAnswer[0]
                                                          .optionD
                                                      )
                                                    }
                                                  >
                                                    <DeleteIcon />
                                                  </Button>
                                                </div>
                                              )}
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      )}
                                      <br />
                                      <div className="quiz-parent-segment-title">
                                        Choose Correct Option
                                      </div>
                                      <div>
                                        <FormControl fullWidth size="small">
                                          <InputLabel id="quiz-type-select">
                                            Select Correct Option
                                          </InputLabel>
                                          <Select
                                            labelId="correct-answers-single-select-label"
                                            id="correct-answers-single-select"
                                            value={
                                              updateData.correctAnswer[0]
                                                ?.correctOption || ""
                                            }
                                            onChange={(e) => {
                                              const updatedCorrectAnswer = [
                                                ...updateData.correctAnswer,
                                              ];
                                              updatedCorrectAnswer[0] = {
                                                ...updatedCorrectAnswer[0],
                                                correctOption: e.target.value, // Update correctOption within correctAnswer[0]
                                              };

                                              setUpdateData({
                                                ...updateData,
                                                correctAnswer:
                                                  updatedCorrectAnswer,
                                              });
                                            }}
                                            input={
                                              <OutlinedInput
                                                id="select-single"
                                                label="Select Correct Option"
                                              />
                                            }
                                            renderValue={(selected) => (
                                              <Box
                                                sx={{
                                                  display: "flex",
                                                  flexWrap: "wrap",
                                                  gap: 0.5,
                                                }}
                                              >
                                                <Chip
                                                  key={selected}
                                                  label={selected}
                                                />
                                              </Box>
                                            )}
                                          >
                                            <MenuItem value="optionA">
                                              <Radio
                                                checked={
                                                  updateData.correctAnswer[0]
                                                    ?.correctOption ===
                                                  "optionA"
                                                }
                                              />
                                              <ListItemText primary="optionA" />
                                            </MenuItem>
                                            <MenuItem value="optionB">
                                              <Radio
                                                checked={
                                                  updateData.correctAnswer[0]
                                                    ?.correctOption ===
                                                  "optionB"
                                                }
                                              />
                                              <ListItemText primary="B" />
                                            </MenuItem>
                                            <MenuItem value="optionC">
                                              <Radio
                                                checked={
                                                  updateData.correctAnswer[0]
                                                    ?.correctOption ===
                                                  "optionC"
                                                }
                                              />
                                              <ListItemText primary="optionC" />
                                            </MenuItem>
                                            <MenuItem value="optionD">
                                              <Radio
                                                checked={
                                                  updateData.correctAnswer[0]
                                                    ?.correctOption ===
                                                  "optionD"
                                                }
                                              />
                                              <ListItemText primary="optionD" />
                                            </MenuItem>
                                          </Select>
                                        </FormControl>
                                      </div>
                                    </Grid>
                                  </Grid>
                                </div>
                              </div>
                            )}

                            {/* Yes/No Options Area */}
                            {updateData.correctAnswer[0].answerType ===
                              "yesNoOptions" && (
                              <div>
                                {/* Options Area */}
                                <div className="quiz-parent-segment-div">
                                  <Grid container spacing={2}>
                                    <Grid item xs={15}>
                                      {/* You can add Quiz Media Preview here */}
                                    </Grid>
                                    <Grid item xs={15}>
                                      <div className="quiz-parent-segment-title">
                                        Choose Correct Option(s)
                                      </div>
                                      <div>
                                        <FormControl fullWidth size="small">
                                          <InputLabel id="quiz-type-select">
                                            Select Correct Option(s)
                                          </InputLabel>
                                          <Select
                                            labelId="correct-answers-multiselect-chip-label"
                                            id="correct-answers-multiselect-chip"
                                            multiple
                                            value={
                                              updateData.correctAnswer[0]
                                                .correctOption
                                            }
                                            onChange={(e) => {
                                              const { value } = e.target;
                                              setUpdateData((prevState) => {
                                                const currentOptions =
                                                  prevState.correctAnswer[0]
                                                    .correctOption;
                                                const newOptions =
                                                  typeof value === "string"
                                                    ? value.split(",")
                                                    : value;

                                                // Find selected values that are not currently in the state (added) and values that were removed
                                                const updatedOptions =
                                                  newOptions.filter(
                                                    (option) =>
                                                      currentOptions.includes(
                                                        option
                                                      )
                                                        ? false // Remove if already present (unchecking)
                                                        : true // Add if not present
                                                  );

                                                return {
                                                  ...prevState,
                                                  correctAnswer: [
                                                    {
                                                      ...prevState
                                                        .correctAnswer[0],
                                                      correctOption:
                                                        updatedOptions,
                                                    },
                                                  ],
                                                };
                                              });
                                            }}
                                            input={
                                              <OutlinedInput
                                                id="select-multiple-chip"
                                                label="Select Correct Option(s)"
                                              />
                                            }
                                            renderValue={(selected) => (
                                              <Box
                                                sx={{
                                                  display: "flex",
                                                  flexWrap: "wrap",
                                                  gap: 0.5,
                                                }}
                                              >
                                                {selected.map((value) => (
                                                  <Chip
                                                    key={value}
                                                    label={value}
                                                  />
                                                ))}
                                              </Box>
                                            )}
                                          >
                                            <MenuItem value="yes">
                                              <Checkbox
                                                checked={
                                                  updateData.correctAnswer[0].correctOption.indexOf(
                                                    "yes"
                                                  ) > -1
                                                }
                                              />
                                              <ListItemText primary="YES" />
                                            </MenuItem>
                                            <MenuItem value="no">
                                              <Checkbox
                                                checked={
                                                  updateData.correctAnswer[0].correctOption.indexOf(
                                                    "no"
                                                  ) > -1
                                                }
                                              />
                                              <ListItemText primary="NO" />
                                            </MenuItem>
                                          </Select>
                                        </FormControl>
                                      </div>
                                    </Grid>
                                  </Grid>
                                </div>
                              </div>
                            )}
                          </div>
                        ) : null}
                      </>
                    ) : null}
                    {updateData?.gameType === "matching" &&
                      updateData?.correctAnswer?.length > 0 &&
                      updateData?.correctAnswer.map((question, index) => (
                        <Grid
                          container
                          spacing={3}
                          style={{ marginTop: "0.5px" }}
                          key={index}
                        >
                          <Grid item xs={5}>
                            {renderUpdateQuestionInputs(
                              question,
                              index,
                              "left"
                            )}
                          </Grid>
                          <Grid item xs={5}>
                            {renderUpdateQuestionInputs(
                              question,
                              index,
                              "right"
                            )}
                          </Grid>
                          <Grid item xs={2}>
                            {index === 0 ? (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                {updateData?.correctAnswer?.length > 1 && (
                                  <Button
                                    onClick={() =>
                                      handleUpdateRemoveQuestion(index)
                                    }
                                    variant="contained"
                                    color="error"
                                    style={{ marginTop: "10px" }}
                                  >
                                    -
                                  </Button>
                                )}
                                <Button
                                  onClick={handleUpdateAddQuestion}
                                  variant="contained"
                                  color="primary"
                                  style={{
                                    marginLeft: "10px",
                                    marginTop: "10px",
                                  }}
                                >
                                  +
                                </Button>
                              </div>
                            ) : (
                              <Button
                                onClick={() =>
                                  handleUpdateRemoveQuestion(index)
                                }
                                variant="contained"
                                color="error"
                                style={{ marginTop: "10px" }}
                              >
                                -
                              </Button>
                            )}
                          </Grid>
                        </Grid>
                      ))}
                    {updateData?.gameType === "rearrangement" &&
                      updateData?.correctAnswer?.length > 0 &&
                      updateData?.correctAnswer.map((sentence, index) => (
                        <Grid
                          container
                          spacing={3}
                          style={{ marginTop: "10px" }}
                          key={index}
                        >
                          <Grid item xs={10}>
                            <TextField
                              fullWidth
                              variant="outlined"
                              size="small"
                              value={sentence?.wordValue}
                              onChange={(e) =>
                                handleUpdateSentenceRearrangementChange(
                                  index,
                                  e
                                )
                              }
                            />
                          </Grid>
                          <Grid
                            item
                            xs={2}
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {index === 0 ? (
                              <>
                                {updateData?.correctAnswer?.length > 1 && (
                                  <Button
                                    onClick={() =>
                                      handleUpdateRemoveSentenceRearrangement(
                                        index
                                      )
                                    }
                                    variant="contained"
                                    color="error"
                                  >
                                    -
                                  </Button>
                                )}
                                <Button
                                  onClick={handleUpdateAddSentenceRearrangement}
                                  variant="contained"
                                  color="primary"
                                  style={{ marginLeft: "10px" }}
                                >
                                  +
                                </Button>
                              </>
                            ) : (
                              <Button
                                onClick={() =>
                                  handleUpdateRemoveSentenceRearrangement(index)
                                }
                                variant="contained"
                                color="error"
                              >
                                -
                              </Button>
                            )}
                          </Grid>
                        </Grid>
                      ))}
                    {updateData?.gameType === "puzzle" &&
                      updateData?.correctAnswer?.length > 0 &&
                      updateData?.correctAnswer.map((question, index) => (
                        <Grid
                          container
                          spacing={3}
                          style={{ marginTop: "10px" }}
                          key={index}
                        >
                          <Grid item xs={10}>
                            <TextField
                              fullWidth
                              variant="outlined"
                              size="small"
                              value={question.wordValue}
                              onChange={(e) =>
                                handleUpdatePuzzleQuestionChange(index, e)
                              }
                            />
                          </Grid>
                          <Grid
                            item
                            xs={2}
                            style={{
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            {index === 0 ? (
                              <>
                                {updateData?.correctAnswer?.length > 1 && (
                                  <Button
                                    onClick={() =>
                                      handleUpdateRemovePuzzleQuestion(index)
                                    }
                                    variant="contained"
                                    color="error"
                                  >
                                    -
                                  </Button>
                                )}
                                <Button
                                  onClick={handleUpdateAddPuzzleQuestion}
                                  variant="contained"
                                  color="primary"
                                  style={{ marginLeft: "10px" }}
                                >
                                  +
                                </Button>
                              </>
                            ) : (
                              <Button
                                onClick={() =>
                                  handleUpdateRemovePuzzleQuestion(index)
                                }
                                variant="contained"
                                color="error"
                              >
                                -
                              </Button>
                            )}
                          </Grid>
                        </Grid>
                      ))}

                    {updateData?.gameType === "fillInBlanks" &&
                      updateData?.fillInBlanksArr?.length > 0 &&
                      updateData?.fillInBlanksArr.map(
                        (question, questionIndex) => (
                          <div
                            key={questionIndex}
                            style={{ marginTop: "10px" }}
                          >
                            <TextField
                              fullWidth
                              variant="outlined"
                              size="small"
                              value={question?.text}
                              onChange={(e) =>
                                handleUpdateParagraphTextChange(
                                  e.target.value,
                                  questionIndex
                                )
                              }
                              multiline
                              rows={4}
                            />
                            <Button
                              onClick={() =>
                                handleUpdateBlankInsert(questionIndex)
                              }
                              variant="contained"
                              color="primary"
                              style={{
                                marginTop: "10px",
                                marginBottom: "10px",
                              }}
                            >
                              Insert Blank
                            </Button>

                            {question?.correctInput?.map(
                              (answer, answerIndex) => (
                                <TextField
                                  fullWidth
                                  variant="outlined"
                                  size="small"
                                  label={`Answer ${answerIndex + 1}`}
                                  value={answer?.answer}
                                  onChange={(e) =>
                                    handleUpdateAnswerChange(
                                      questionIndex,
                                      answerIndex,
                                      e.target.value
                                    )
                                  }
                                  style={{ marginTop: "10px" }}
                                  key={answerIndex}
                                />
                              )
                            )}

                            {question?.options?.map((option, optionIndex) => (
                              <div
                                key={optionIndex}
                                style={{ marginTop: "20px" }}
                              >
                                <TextField
                                  fullWidth
                                  variant="outlined"
                                  size="small"
                                  label={`Option ${optionIndex + 1}`}
                                  value={option}
                                  onChange={(e) =>
                                    handleUpdateParagraphOptionChange(
                                      questionIndex,
                                      optionIndex,
                                      e.target.value
                                    )
                                  }
                                />
                                <Button
                                  onClick={() =>
                                    handleUpdateRemoveParagraphOption(
                                      questionIndex,
                                      optionIndex
                                    )
                                  }
                                  variant="contained"
                                  color="error"
                                  style={{
                                    marginTop: "10px",
                                    marginLeft: "10px",
                                  }}
                                >
                                  Remove Option
                                </Button>
                              </div>
                            ))}

                            <Button
                              onClick={() =>
                                handleUpdateAddParagraphOption(questionIndex)
                              }
                              variant="contained"
                              color="primary"
                              style={{ marginTop: "10px" }}
                            >
                              Add Option
                            </Button>
                          </div>
                        )
                      )}
                  </div>
                </Grid>
                <Grid item xs={2}>
                  <div></div>
                </Grid>
              </Grid>
            </div>
            {/* --------------------- */}
          </div>
          <div style={{ marginBottom: "100px" }}>
            <Button
              variant="outlined"
              style={{ marginLeft: 12 }}
              onClick={handleCloseUpdate}
            >
              Close
            </Button>
            {loadingUpdate ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "right",
                }}
              >
                <CircularProgress />
              </div>
            ) : (
              <Button variant="contained" onClick={updateQuiz}>
                Update
              </Button>
            )}
          </div>
        </Box>
      </Modal>

      <ToastContainer />
    </div>
  );
};

export default GamifiedModule;
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  bgcolor: "background.paper",
  // border: "2px solid #000",
  boxShadow: 24,
  height: "80%",
  p: 4,
  overflowY: "auto",
  paddingBottom: "20px",
};
